
function SiteURL(type) {
    if (type == "add") {
        return window.location.origin + "/cart/add.js";
    } else if (type == "change") {
        return window.location.origin + "/cart/change.js";
    } else if (type == "update") {
        return window.location.origin + "/cart/update.js";
    }
}

function ownKeys(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        t && (s = s.filter((function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
        }
        ))),
        i.push.apply(i, s)
    }
    return i
}
function _objectSpread(e) {
    for (var t = 1; t < arguments.length; t++) {
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(i), !0).forEach((function(t) {
            _defineProperty(e, t, i[t])
        }
        )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ownKeys(Object(i)).forEach((function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t))
        }
        ))
    }
    return e
}
function _defineProperty(e, t, i) {
    return t in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = i,
    e
}
(e=>{
    e.utils = new class {
        constructor() {
            this._handleize(),
            this._rendered_numbers = []
        }
        _handleize() {
            for (var e = [{
                base: "A",
                letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
            }, {
                base: "AA",
                letters: "Ꜳ"
            }, {
                base: "AE",
                letters: "ÆǼǢ"
            }, {
                base: "AO",
                letters: "Ꜵ"
            }, {
                base: "AU",
                letters: "Ꜷ"
            }, {
                base: "AV",
                letters: "ꜸꜺ"
            }, {
                base: "AY",
                letters: "Ꜽ"
            }, {
                base: "B",
                letters: "BⒷＢḂḄḆɃƂƁ"
            }, {
                base: "C",
                letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
            }, {
                base: "D",
                letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
            }, {
                base: "DZ",
                letters: "ǱǄ"
            }, {
                base: "Dz",
                letters: "ǲǅ"
            }, {
                base: "E",
                letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
            }, {
                base: "F",
                letters: "FⒻＦḞƑꝻ"
            }, {
                base: "G",
                letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
            }, {
                base: "H",
                letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
            }, {
                base: "I",
                letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
            }, {
                base: "J",
                letters: "JⒿＪĴɈ"
            }, {
                base: "K",
                letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
            }, {
                base: "L",
                letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
            }, {
                base: "LJ",
                letters: "Ǉ"
            }, {
                base: "Lj",
                letters: "ǈ"
            }, {
                base: "M",
                letters: "MⓂＭḾṀṂⱮƜ"
            }, {
                base: "N",
                letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
            }, {
                base: "NJ",
                letters: "Ǌ"
            }, {
                base: "Nj",
                letters: "ǋ"
            }, {
                base: "O",
                letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
            }, {
                base: "OI",
                letters: "Ƣ"
            }, {
                base: "OO",
                letters: "Ꝏ"
            }, {
                base: "OU",
                letters: "Ȣ"
            }, {
                base: "OE",
                letters: "Œ"
            }, {
                base: "oe",
                letters: "œ"
            }, {
                base: "P",
                letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
            }, {
                base: "Q",
                letters: "QⓆＱꝖꝘɊ"
            }, {
                base: "R",
                letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
            }, {
                base: "S",
                letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
            }, {
                base: "T",
                letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
            }, {
                base: "TZ",
                letters: "Ꜩ"
            }, {
                base: "U",
                letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
            }, {
                base: "V",
                letters: "VⓋＶṼṾƲꝞɅ"
            }, {
                base: "VY",
                letters: "Ꝡ"
            }, {
                base: "W",
                letters: "WⓌＷẀẂŴẆẄẈⱲ"
            }, {
                base: "X",
                letters: "XⓍＸẊẌ"
            }, {
                base: "Y",
                letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
            }, {
                base: "Z",
                letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
            }, {
                base: "a",
                letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
            }, {
                base: "aa",
                letters: "ꜳ"
            }, {
                base: "ae",
                letters: "æǽǣ"
            }, {
                base: "ao",
                letters: "ꜵ"
            }, {
                base: "au",
                letters: "ꜷ"
            }, {
                base: "av",
                letters: "ꜹꜻ"
            }, {
                base: "ay",
                letters: "ꜽ"
            }, {
                base: "b",
                letters: "bⓑｂḃḅḇƀƃɓ"
            }, {
                base: "c",
                letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
            }, {
                base: "d",
                letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
            }, {
                base: "dz",
                letters: "ǳǆ"
            }, {
                base: "e",
                letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
            }, {
                base: "f",
                letters: "fⓕｆḟƒꝼ"
            }, {
                base: "g",
                letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
            }, {
                base: "h",
                letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
            }, {
                base: "hv",
                letters: "ƕ"
            }, {
                base: "i",
                letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
            }, {
                base: "j",
                letters: "jⓙｊĵǰɉ"
            }, {
                base: "k",
                letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
            }, {
                base: "l",
                letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
            }, {
                base: "lj",
                letters: "ǉ"
            }, {
                base: "m",
                letters: "mⓜｍḿṁṃɱɯ"
            }, {
                base: "n",
                letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
            }, {
                base: "nj",
                letters: "ǌ"
            }, {
                base: "o",
                letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
            }, {
                base: "oi",
                letters: "ƣ"
            }, {
                base: "ou",
                letters: "ȣ"
            }, {
                base: "oo",
                letters: "ꝏ"
            }, {
                base: "p",
                letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
            }, {
                base: "q",
                letters: "qⓠｑɋꝗꝙ"
            }, {
                base: "r",
                letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
            }, {
                base: "s",
                letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
            }, {
                base: "t",
                letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
            }, {
                base: "tz",
                letters: "ꜩ"
            }, {
                base: "u",
                letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
            }, {
                base: "v",
                letters: "vⓥｖṽṿʋꝟʌ"
            }, {
                base: "vy",
                letters: "ꝡ"
            }, {
                base: "w",
                letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
            }, {
                base: "x",
                letters: "xⓧｘẋẍ"
            }, {
                base: "y",
                letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
            }, {
                base: "z",
                letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
            }], t = {}, i = 0; i < e.length; i++)
                for (var s = e[i].letters.split(""), r = 0; r < s.length; r++)
                    t[s[r]] = e[i].base;
            String.prototype.noAccents = function(e, i) {
                var s = this.replace(/[^\u0000-\u007E]/g, (function(e) {
                    return t[e] || e
                }
                ));
                return i = i || "",
                e && (s = s.replace(/[^\u0000-\u007E]/g, i)),
                s
            }
            ,
            String.prototype.handleize = function(e, t) {
                return e = e || "-",
                t = t || "",
                this.noAccents(!0, t).trim().replace(/[^a-z0-9\s-/]/gi, t).replace(/[\s/]/gi, e).toLowerCase()
            }
        }
        toMoney(t, i={}) {
            if (!t)
                return console.warn("Utilities.toMoney: Invalid price passed.", t),
                null;
            let s, r = {
                style: "currency"
            };
            return t = new Number(t),
            i.cents = i.cents || !1,
            i.locale = i.locale || (e.shop ? e.shop.locale : null) || "en-CA",
            r.currency = i.currency || (e.shop ? e.shop.currency : null) || "CAD",
            i.cents && (t /= 100),
            s = t.toLocaleString(i.locale, r),
            i.no_zeros && ~s.indexOf(".00") && (s = s.replace(".00", "")),
            s
        }
        removeProtocol(e) {
            return e ? e.replace(/http(s)?:/, "") : (console.error("Utilities.removeProtocol: Invalid path passed.", e),
            null)
        }
        getSizedImageUrl(e, t) {
            if (!t)
                return console.error("Utilities.getSizedImageUrl: Invalid size passed.", t),
                e;
            if ("master" === t)
                return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (i) {
                var s = e.split(i[0])
                  , r = i[0];
                return this.removeProtocol(s[0] + "_" + t + r)
            }
            return console.error("Utilities.getSizedImageUrl: Invalid image URL passed.", e),
            null
        }
        toObject(e) {
            var t = {};
            return e ? (e.split("&").forEach(e=>{
                let i = e.indexOf("=");
                if (-1 == i)
                    t[decodeURIComponent(e)] = null;
                else {
                    let s = decodeURIComponent(e.slice(0, i))
                      , r = decodeURIComponent(e.slice(i + 1)) || null;
                    t[s] = r
                }
            }
            ),
            t) : {}
        }
        getURLParams(e) {
            var t = (e = e || window.location.href).split(/\?([^\#]+)/)[1];
            return t ? this.toObject(t) : {}
        }
        setURLParams(e, t={}) {
            const i = this.getURLParams();
            let s = t.clear ? {} : i
              , r = []
              , o = "";
            Object.keys(e).forEach(i=>{
                let r = e[i];
                s[i] = t.no_overwrite && s[i] || r
            }
            ),
            Object.keys(s).forEach(e=>{
                r.push(encodeURIComponent(e) + "=" + encodeURIComponent(s[e]))
            }
            ),
            r.length && (o = "?" + r.join("&")),
            t.push_state ? window.history.pushState({}, null, o) : window.history.replaceState({}, null, o)
        }
        modifyObject(e, t, i) {
            let s = (i = i || {}).clear ? {} : e || {};
            return e && t && "object" == typeof t ? (Object.keys(t).forEach(e=>{
                s[e] = i.no_overwrite && s[e] || t[e]
            }
            ),
            s) : s || {}
        }
        uniqueNumber(e) {
            e = e || 6;
            for (var t = Math.floor(Math.random() * Math.pow(10, e)); -1 !== this._rendered_numbers.indexOf(t); )
                t = Math.floor(Math.random() * Math.pow(10, e));
            return this._rendered_numbers.push(t),
            t
        }
        decodeHTML(e) {
            const t = document.createElement("textarea");
            return t.innerHTML = e,
            t.value
        }
        isMatchingMedia(e, t="min") {
            let i = null;
            if ("min" === t)
                i = window.matchMedia(`(min-width: ${e})`);
            else {
                if ("max" !== t)
                    throw new Error('invalid boundType. Use "min" or "max", defaults to min if none is passed.');
                i = window.matchMedia(`(max-width: ${e})`)
            }
            return i.matches
        }
    }
}
)(window.theme = window.theme || {}),
(e=>{
    const t = document.getElementById("js-bundle-data");
    if (t) {
        const i = {
            debug: !1,
            state: {
                bundleData: {},
                bundleProduct: {},
                bundleProductColour: "",
                bundleProductSize: ""
            },
            setBundleDataAction(e) {
                this.debug && console.log("setBundleDataAction triggered with", e),
                this.state.bundleData = e
            },
            getBundleData() {
                return this.state.bundleData
            },
            setBundleProductAndVariant(e, t=e.selected_or_first_available_variant) {
                this.state.bundleProductColour = t.option2 || t.option1,
                this.state.bundleProductSize = this.getSizeValue(t.option1),
                this.setBundleProduct(e)
            },
            setBundleProduct(e) {
                this.state.bundleProduct = e
            },
            getSizeValue: e=>e.toLowerCase().includes("mini") ? "mini" : "standard"
        };
        i.setBundleDataAction(JSON.parse(t.innerHTML)),
        i.setBundleProductAndVariant(i.state.bundleData.products[0]),
        e.bundleDataStore = i
    }
}
)(window.theme = window.theme || {}),
((e,t)=>{
    e.cart = new class {
        constructor(e) {
            this.content = e || {},
            this._queue = t.when(),
            e || this.fetch()
        }
        get content() {
            return this._object
        }
        set content(e) {
            this._object = e || this._object,
            t(document).trigger("Cart:set", this.content)
        }
        fetch({silent: e=!1}={}) {
            return this._queue = this._queue.then(()=>t.ajax({
                url: "/cart.js",
                type: "GET",
                dataType: "json"
            }).done(i=>{
                this.content = i,
                e || t(document).trigger("Cart:fetch", this.content)
            }
            ).fail(e=>{
                console.error("Cart.fetch: Failed getting the cart.", e),
                console.warn("Clearing the theme.cart._queue object"),
                this._queue = t.when()
            }
            )),
            this._queue
        }
    
        add(e, {silent: i=!1}={}) {
         
            return e ? ("object" != typeof e && (e = {
                id: e
            }),
            e.quantity = e.quantity || 1,
            this._queue = this._queue.then(()=>t.ajax({
                url: SiteURL("add"),
                data: e,
                type: "POST",
                dataType: "json"
            }).done(e=>{
                this.fetch({
                    silent: i
                }),
                i || t(document).trigger("Cart:add", e)
            }
            ).fail(e=>{
                console.error("Cart.add: Failed adding to the cart.", e),
                console.warn("Clearing the theme.cart._queue object"),
                this._queue = t.when()
            }
            )),
            this._queue) : (console.warn("Cart.add: No item was passed."),
            t.when())
        }
        update(e, {silent: i=!1}={}) {
            if (!e)
                return console.warn("Cart.update: No item was passed."),
                t.when();
            let s = {};
            const r = e=>{
                if ("object" == typeof e) {
                    if (!e.id)
                        return console.warn("Cart.update: No id was passed with the product object."),
                        t.when();
                    s[e.id] = e.quantity || 0 === e.quantity ? e.quantity : 1
                } else
                    s[e] = 1
            }
            ;
            return Array.isArray(e) ? e.forEach(e=>{
                r(e)
            }
            ) : r(e),
            Object.keys(s).length ? (this._queue = this._queue.then(()=>t.ajax({
                url: "/cart/update.js",
                data: {
                    updates: s
                },
                type: "POST",
                dataType: "json"
            }).done(s=>{
                this.content = s,
                i || t(document).trigger("Cart:update", [s, e])
            }
            ).fail(e=>{
                console.error("Cart.update: Failed updating a cart item.", e),
                console.warn("Clearing the theme.cart._queue object"),
                this._queue = t.when()
            }
            )),
            this._queue) : t.when()
        }
        change(e, {silent: i=!1}={}) {
            return e ? ("object" != typeof e && (e = {
                id: e,
                quantity: 1
            }),
            this._queue = this._queue.then(()=>t.ajax({
                url:  SiteURL("change"),
                data: e,
                type: "POST",
                dataType: "json"
            }).done(s=>{
                this.content = s,
                i || t(document).trigger("Cart:change", [s, e])
            }
            ).fail(e=>{
                console.error("Cart.change: Failed changing a cart quantity.", e),
                console.warn("Clearing the theme.cart._queue object"),
                this._queue = t.when()
            }
            )),
            this._queue) : (console.warn("Cart.change: No item was passed."),
            t.when())
        }
        remove(e, {silent: i=!1}={}) {
            if (!e)
                return console.warn("Cart.remove: No item was passed."),
                t.when();
            let s = [];
            return Array.isArray(e) ? e.forEach(e=>{
                s.push({
                    id: "object" == typeof e ? e.id : e,
                    quantity: 0
                })
            }
            ) : s.push({
                id: "object" == typeof e ? e.id : e,
                quantity: 0
            }),
            this.update(s, {
                silent: i
            })
        }
        clear({silent: e=!1}={}) {
            return this._queue = this._queue.then(()=>t.ajax({
                url: "/cart/clear.js",
                type: "POST",
                dataType: "json"
            }).done(i=>{
                this.content = i,
                e || t(document).trigger("Cart:clear", i)
            }
            ).fail(e=>{
                console.error("Cart.clear: Failed clearing the cart.", e),
                console.warn("Clearing the theme.cart._queue object"),
                this._queue = t.when()
            }
            )),
            this._queue
        }
        updateAttributes(e, {no_overwrite: i=!1, silent: s=!1}={}) {
            if (!e)
                return console.warn("Cart.updateAttribute: No attributes were passed."),
                t.when();
            let r = {};
            if (i)
                for (let t of Object.keys(e))
                    this.content.attributes[t] || (r[t] = e[t]);
            else
                r = e;
            return Object.keys(r).length ? (this._queue = this._queue.then(()=>t.ajax({
                url: "/cart/update.js",
                data: {
                    attributes: r
                },
                type: "POST",
                dataType: "json"
            }).done(e=>{
                this.content = e,
                s || t(document).trigger("Cart:update", [e, r])
            }
            ).fail(e=>{
                console.error("Cart.attributeUpdate: Failed updating a cart attribute.", e),
                console.warn("Clearing the theme.cart._queue object"),
                this._queue = t.when()
            }
            )),
            this._queue) : t.when()
        }
        clearAttributes(t, {silent: i=!1}={}) {
            let s = {};
            const r = void 0 !== t ? [].concat(t || []) : Object.keys(e.cart.content.attributes);
            for (let e of r)
                s[e] = "";
            return this.updateAttributes(s, {
                silent: i
            })
        }
    }
    (e.cart || null)
}
)(window.theme = window.theme || {}, jQuery),
((e,t,i)=>{
    const s = []
      , r = "js-flyout"
      , o = "u-no-scroll"
      , a = "is-active"
      , n = "cart-flyout-open";
    class l {
        constructor(e) {
            if (!e)
                return console.error("Flyout.constructor: No element was passed."),
                !1;
            const i = e.data("scroll-area");
            let s = e[0];
            i && ([s] = e.find(`.${i}`)),
            this.elements = {
                flyout: e,
                scrollableArea: s
            },
            this.id = e.data("flyout-id") || !1,
            this.options = e.data("flyout-options") || !1,
            this.max = this.options.max && Math.floor(this.options.max) !== this.options.max && !t.isNumeric(this.options.max) || this.max < 0 ? -1 : this.options.max,
            this.min = this.options.min && Math.floor(this.options.min) !== this.options.min && !t.isNumeric(this.options.min) || this.options.min < 0 ? -1 : this.options.min,
            this.disabled = this.isDisabled(),
            this.hidden = !1,
            this.id && (this.bindTriggers(),
            this.addRoles(),
            this.hideFlyout(),
            this.run())
        }
        run() {
            let e = t(window).width();
            t(window).resize(()=>{
                t(window).width() !== e && (e = t(window).width(),
                this.refresh())
            }
            )
        }
        refresh() {
            this.disabled = this.isDisabled(),
            this.bindTriggers(),
            this.addRoles(),
            this.hideFlyout()
        }
        isDisabled() {
            return -1 === this.max || -1 === this.min || (this.max < t(window).width() || this.min > t(window).width())
        }
        static addRole(e) {
            "Button" === e.prop("tagName") || "submit" === e.attr("type") || e.attr("role") || e.attr("aria-role") || (e.attr("role", "button"),
            e.attr("aria-role", "button"))
        }
        addRoles() {
            t([this.elements.toggle, this.elements.open, this.elements.close]).each((e,i)=>{
                l.addRole(t(i))
            }
            )
        }
        bindTriggers() {
            return this.elements.toggle = t.find(`[data-flyout-toggle="${this.id}"]`),
            this.elements.open = t.find(`[data-flyout-open="${this.id}"]`),
            this.elements.close = t.find(`[data-flyout-close="${this.id}"]`),
            this.disabled ? (t(document).off(`click.flyout-${this.id}`),
            t(this.elements.toggle).off(`click.flyout-${this.id}`),
            t(this.elements.open).off(`click.flyout-${this.id}`),
            t(this.elements.close).off(`click.flyout-${this.id}`),
            !1) : (t(document).off(`click.flyout-${this.id}`),
            t(document).on(`click.flyout-${this.id}`, `[data-flyout-toggle='${this.id}']`, e=>{
                e.preventDefault(),
                this.toggle()
            }
            ),
            t(document).on(`click.flyout-${this.id}`, `[data-flyout-open='${this.id}']`, e=>{
                e.preventDefault(),
                this.open()
            }
            ),
            t(document).on(`click.flyout-${this.id}`, `[data-flyout-close='${this.id}']`, e=>{
                e.preventDefault(),
                this.close()
            }
            ),
            !1)
        }
        hideFlyout() {
            return this.disabled ? (this.elements.flyout.hide().removeClass(a),
            this.hidden = !1,
            t("html").removeClass(o),
            !1) : (this.hidden || (this.elements.flyout.removeClass(a),
            this.hidden = !0),
            i.enableBodyScroll(this.elements.scrollableArea),
            !1)
        }
        open() {
            s.forEach(e=>{
                this.id === e.id || e.hidden || e.close()
            }
            ),
            t("html").addClass(o),
            "cart-flyout" === this.id && t("body").addClass(n);
            let e = 0;
            if (t(".js-header").length > 0) {
                e = t(".js-header").outerHeight()
            }
            this.elements.flyout.css("top", `${e}px`),
            this.elements.flyout.show().addClass(a).on("transitionend webkittransitionEnd otransitionEnd MStransitionEnd", e=>{
                t(this).trigger("Flyout:open"),
                t(this).off(e)
            }
            ),
            this.hidden = !1
        }
        close() {
            t("html").removeClass(o),
            t("body").removeClass(n),
            this.elements.flyout.removeClass(a),
            this.elements.flyout.on("transitionend webkittransitionEnd otransitionEnd MStransitionEnd", e=>{
                t(this).off(e),
                t(this).trigger("Flyout:close")
            }
            ),
            this.hidden = !0
        }
        toggle() {
            this.elements.flyout.trigger("Flyout:toggle");
            const e = this.elements.scrollableArea;
            this.hidden ? (this.open(),
            i.disableBodyScroll(e)) : (this.close(),
            i.enableBodyScroll(e))
        }
    }
    e.Flyout = l,
    t(`.${r}`).each((function() {
        s.push(new e.Flyout(t(this)))
    }
    ))
}
)(window.theme = window.theme || {}, jQuery, window.bodyScrollLock),
((e,t)=>{
    e.products = new class {
        constructor(e) {
            this._list = e || {}
        }
        get list() {
            return this._list
        }
        set list(e) {
            return !1
        }
        update(i) {
            if (!i || "object" != typeof i)
                return !1;
            i.handle ? i = [i] : Array.isArray(i) || (i = Object.keys(i).map(e=>i[e]).filter(e=>e.handle)),
            i.forEach(i=>{
                if (i.handle)
                    if (this._list[i.handle]) {
                        let s = e.utils.modifyObject(this._list[i.handle], i);
                        this._list[i.handle] = s,
                        t(document).trigger("Products:update", s)
                    } else
                        this._list[i.handle] = i,
                        t(document).trigger("Products:add", i)
            }
            )
        }
    }
    (e.products && e.products.list ? e.products.list : {})
}
)(window.theme = window.theme || {}, jQuery),
(e=>{
    class t {
        constructor(e, t={}) {
            this.selector = e,
            this.settings = _objectSpread({}, {
                active: ".js-gallery-slide.is-active",
                bg: ".js-gallery-bg",
                info: ".js-gallery-info",
                light: !0,
                animateBg: !0
            }, {}, t)
        }
        go(e) {
            const t = this.getCurrSlide();
            if (!t.classList.contains("is-anim--out")) {
                const i = document.querySelector(`.js-gallery-slide[data-image-id="${e}"]`) || document.querySelector(".js-gallery-slide");
                if (null !== i && t !== i) {
                    if (t.classList.add("is-anim-out"),
                    this.settings.animateBg) {
                        const e = this.getColor(i);
                        this.updateBg(e)
                    }
                    setTimeout(()=>{
                        t.style.display = "none",
                        t.classList.remove("is-active", "is-anim-out"),
                        i.classList.add("is-active"),
                        setTimeout(()=>{
                            t.style.display = "initial"
                        }
                        , 300)
                    
                    	var activeSlides = $(".js-gallery-slide.is-active"); 
   					    if(activeSlides.length>1){ $(activeSlides[1]).removeClass("is-active");}
                    }
                    , 500)
                }
            }
            return this
        }
        updateBg(e) {
            if ("" !== e) {
                const t = document.querySelector(this.settings.bg);
                t.classList.add("is-anim"),
                t.style.backgroundColor = e,
                this.settings.light && ("#ffffff" !== e ? this.updateInfoColor("light") : this.updateInfoColor("dark")),
                setTimeout(()=>{
                    t.classList.remove("is-anim")
                }
                , 500)
            }
            return this
        }
        updateInfoColor(e) {
            document.querySelectorAll(this.settings.info).forEach(t=>{
                "light" === e ? t.classList.add("is-light") : t.classList.remove("is-light")
            }
            )
        }
        getColor(e) {
            return "color"in e.dataset ? e.dataset.color : "#ffffff"
        }
        get slide() {
            return this.getCurrSlide()
        }
        getCurrSlide() {
            return document.querySelector(this.settings.active)
        }
    }
    null !== document.querySelector(".js-pdp-gallery") && (e.slideGallery = new t(".js-pdp-gallery"))
}
)(window.theme = window.theme || {}),
window.theme = window.theme || {},
window.Vue.component("accordion", {
    data: ()=>({
        show: !1
    }),
    methods: {
        toggle() {
            this.show = !this.show
        }
    },
    template: "#js-accordion"
}),
(e=>{
    e.config.devtools = !0,
    e.options.delimiters = ["${", "}"],
    e.use(vuelidate.default);
    const t = function(e) {
        e.directive("Sticky", StickyDirective)
    };
    window.Vue && e.use(t),
    VueSelect.VueSelect.props.components.default = ()=>({
        OpenIndicator: {
            template: "#vue-select-chevron"
        }
    }),
    e.component("v-select", VueSelect.VueSelect)
}
)(Vue),
((e,t)=>{
    window.Vue.component("country-selector", {
        props: {
            modifier: {
                type: String,
                default: "",
                required: !1
            }
        },
        data: ()=>_objectSpread({
            isActive: !1
        }, JSON.parse(document.getElementById("js-country-selector-data").innerHTML)),
        computed: {
            modifierClass() {
                return this.modifier ? `c-country-selector--${this.modifier}` : ""
            },
            currentCountry() {
                return this.countries[this.selectedCountryIndex]
            }
        },
        created() {
            e.vue_event_bus.$on("close_megamenu", ()=>{
                this.close()
            }
            )
        },
        methods: {
            toggle() {
                this.isActive = !this.isActive
            },
            close() {
                this.isActive = !1
            },
            getImgSrcSet: e=>`${e.flagUrl2x} 2x, ${e.flagUrl3x} 3x`,
            getRedirectUrl: e=>`${e.websiteUrl}?redirected=true`
        },
        template: "#js-country-selector-template"
    })
}
)(window.theme = window.theme || {}),
((e,t)=>{
    e.vue_event_bus = new t
}
)(window.theme = window.theme || {}, window.Vue),
window.Vue.filter("truncateText", (e,t=30,i="...")=>e.length <= t ? e : e.slice(0, t - i.length) + i),
((e,t,i)=>{
    t.component("flickity", {
        props: {
            options: {
                type: Object,
                required: !0
            }
        },
        mounted() {
            this.init()
        },
        beforeDestroy() {
            this.$flickity.destroy(),
            this.$flickity = null
        },
        methods: {
            init() {
                this.$flickity = new i(this.$el,this.options),
                this.$emit("init", this.$flickity)
            },
            flickity() {
                return this.$flickity
            },
            select(e, t, i) {
                this.$flickity.select(e, t, i)
            },
            next(e, t) {
                this.$flickity.next(e, t)
            },
            previous(e, t) {
                this.$flickity.previous(e, t)
            },
            selectCell(e, t, i) {
                this.$flickity.selectCell(e, t, i)
            },
            resize() {
                this.$flickity.resize()
            },
            reposition() {
                this.$flickity.reposition()
            },
            prepend(e) {
                this.$flickity.prepend(e)
            },
            append(e) {
                this.$flickity.append(e)
            },
            insert(e, t) {
                this.$flickity.insert(e, t)
            },
            remove(e) {
                this.$flickity.remove(e)
            },
            playPlayer() {
                this.$flickity.playPlayer()
            },
            stopPlayer() {
                this.$flickity.stopPlayer()
            },
            pausePlayer() {
                this.$flickity.pausePlayer()
            },
            unpausePlayer() {
                this.$flickity.unpausePlayer()
            },
            rerender() {
                this.$flickity.destroy(),
                this.init()
            },
            destroy() {
                this.$flickity.destroy()
            },
            reloadCells() {
                this.$flickity.reloadCells()
            },
            getCellElements() {
                return this.$flickity.getCellElements()
            },
            data() {
                return i.data(this.$el)
            },
            on(e, t) {
                this.$flickity.on(e, t)
            },
            off(e, t) {
                this.$flickity.off(e, t)
            },
            once(e, t) {
                this.$flickity.once(e, t)
            },
            selectedElement() {
                return this.$flickity.selectedElement
            },
            selectedElements() {
                return this.$flickity.selectedElements
            },
            selectedIndex() {
                return this.$flickity.selectedIndex
            },
            cells() {
                return this.$flickity.cells
            },
            slides() {
                return this.$flickity.slides
            },
            disableDrag() {
                this.$flickity.options.draggable = !1,
                this.$flickity.updateDraggable()
            },
            enableDrag() {
                this.$flickity.options.draggable = !0,
                this.$flickity.updateDraggable()
            }
        },
        template: "#js-flickity-template"
    })
}
)(window.theme = window.theme || {}, window.Vue, window.Flickity),
(e=>{
    const t = 88
      , i = 108
      , s = {
        day: "numeric",
        month: "short",
        year: "numeric"
    };
    e.vue_mixins = {
        tagProcessors: {
            methods: {
                getTagTextFromArray(e, t) {
                    let i = e;
                    if ("string" == typeof i && (i = i.split(",")),
                    i) {
                        const e = i.filter(e=>e.startsWith(t));
                        if (e.length) {
                            const i = e[0]
                              , s = i.indexOf(t) + t.length;
                            return i.slice(s).replace(/_/g, " ")
                        }
                    }
                    return ""
                },
                getTagText(e, t) {
                    const i = e.indexOf(t) + t.length;
                    return e.slice(i).replace(/_/g, " ")
                }
            }
        },
        articleObject: {
            data: ()=>({
                articleDateTime: "",
                articlePublishedDate: "",
                mainCategoryTag: "",
                placeholderImageSrc: "https://cdn.shopify.com/s/files/1/0857/5574/files/structure-help-help-search-results-image_3x_f465b79c-34f0-41fd-9732-100024f44991.png?38387"
            }),
            mounted() {
                this.articleDateTime = new Date(this.article.published_at).toLocaleDateString({
                    dateStyle: "full"
                }),
                this.articlePublishedDate = new Date(this.article.published_at).toLocaleDateString("en-US", this.dateOptions || s) || "",
                this.mainCategoryTag = this.getTagTextFromArray(this.article.tags, "_category::") || this.article.blog_title || e.blog.title
            }
        },
        stickyHandlers: {
            data: ()=>({
                barIsStuck: !1,
                barOffset: {}
            }),
            created() {
                window.addEventListener("resize", $.debounce(800, this.determineBarOffset)),
                this.determineBarOffset()
            },
            methods: {
                updateStuckState(e) {
                    this.barIsStuck = e.sticked
                },
                determineBarOffset() {
                    const s = parseInt(e.breakpoints.md, 10);
                    window.innerWidth > s ? this.barOffset.top = i : this.barOffset.top = t,
                    this.atcBarReady = !1,
                    this.$nextTick(()=>{
                        this.atcBarReady = !0
                    }
                    )
                }
            }
        },
        modifierClass: {
            props: {
                modifier: {
                    type: [String, Array],
                    default: "",
                    required: !1
                }
            },
            computed: {
                modifierClass() {
                    return this.modifier && this.baseClass ? Array.isArray(this.modifier) ? this.modifier.map(e=>`${this.baseClass}--${e}`).join(" ") : `${this.baseClass}--${this.modifier}` : ""
                }
            }
        }
    }
}
)(window.theme = window.theme || {}),
((e,t)=>{
    window.Vue.component("vue-nav", {
        data: ()=>({
            nav_data: JSON.parse(document.getElementById("js-nav-data").innerHTML)
        }),
        created() {
            e.vue_event_bus.$on("close_megamenu", ()=>{
                this.closeAll()
            }
            )
        },
        methods: {
            toggleActive(t) {
                e.utils.isMatchingMedia(e.breakpoints.md, "max") && (t.is_active && t.blocks && t.blocks.forEach(e=>{
                    e.is_active = !1
                }
                ),
                t.is_active = !t.is_active,
                t.is_active ? t.is_animating = !0 : setTimeout(()=>{
                    t.is_animating = !1
                }
                , 200))
            },
            closeAll(e) {
                this.nav_data.nav_top_links.forEach(t=>{
                    e !== t && (t.is_active = !1),
                    t.blocks.forEach(e=>{
                        e.is_active = !1
                    }
                    )
                }
                )
            },
            toggleTopLinks(t) {
                e.utils.isMatchingMedia(e.breakpoints.md, "max") && (this.closeAll(t),
                this.toggleActive(t))
            },
            checkForBadgeTag: e=>e.tags.filter(e=>e.startsWith("_badge::")).length,
            generateCustomBadgeText(e) {
                if (e && e.tags) {
                    const t = e.tags.filter(e=>e.startsWith("_badge::"));
                    if (t.length) {
                        const e = t[0]
                          , i = e.indexOf("_badge::") + "_badge::".length
                          , s = e.slice(i).replace(/_/g, " ");
                        return s.charAt(0).toUpperCase() + s.slice(1)
                    }
                }
                return ""
            },
               checkForSaveTag: e=>e.tags.filter(e=>e.startsWith("_save::")).length,
            generateCustomSaveText(e) {
                if (e && e.tags) {
                    const t = e.tags.filter(e=>e.startsWith("_save::"));
                    if (t.length) {
                        const e = t[0]
                          , i = e.indexOf("_save::") + "_save::".length
                          , s = e.slice(i).replace(/_/g, " ");
                        return s.charAt(0).toUpperCase() + s.slice(1)
                    }
                }
                return ""
            },
            checkForSaleTag: e=>e.tags.filter(e=>e.startsWith("_sale30::")).length,
            generateCustomSaleText(e) {
                if (e && e.tags) {
                    const t = e.tags.filter(e=>e.startsWith("_sale30::"));
                    if (t.length) {
                        const e = t[0]
                          , i = e.indexOf("_sale30::") + "_sale30::".length
                          , s = e.slice(i).replace(/_/g, " ");
                        return s.charAt(0).toUpperCase() + s.slice(1)
                    }
                }
                return ""
            },
            checkForSaleTag2: e=>e.tags.filter(e=>e.startsWith("_sale20::")).length,
            generateCustomSaleText2(e) {
                if (e && e.tags) {
                    const t = e.tags.filter(e=>e.startsWith("_sale20::"));
                    if (t.length) {
                        const e = t[0]
                          , i = e.indexOf("_sale20::") + "_sale20::".length
                          , s = e.slice(i).replace(/_/g, " ");
                        return s.charAt(0).toUpperCase() + s.slice(1)
                    }
                }
                return ""
            },
            getSizedProdImage(t, i) {
                let s = "";
                return t.length && (s = t),
                e.utils.getSizedImageUrl(s, i)
            }
        },
        template: "#js-nav-template"
    })
}
)(window.theme = window.theme || {}),
((e,t)=>{
    window.Vue.component("product-review", {
        mixins: [e.vue_mixins.modifierClass],
        props: {
            review: {
                type: Object,
                required: !0
            },
            truncateCharLength: {
                type: Number,
                default: 0
            }
        },
        data: ()=>({
            baseClass: "c-review",
            isOpen: !1
        }),
        computed: {
            hasMoreText() {
                return this.isTruncated && !this.isOpen
            },
            isTruncated() {
                return this.review.content.length > this.truncateCharLength
            }
        },
        methods: {
            readMore() {
                this.$emit("read-more-clicked")
            },
            expand() {
                this.isOpen = !0
            }
        },
        template: "#js-product-review"
    })
}
)(window.theme = window.theme || {}),
window.Vue.component("product-tile-feature", {
    props: {
        feature: {
            type: Object,
            required: !0
        }
    },
    template: "#js-product-tile-feature"
}),
((e,t)=>{
    t.component("product-tile", {
        props: {
            modifier: {
                type: [String, Array],
                default: "",
                required: !1
            },
            product: {
                type: Object,
                required: !0
            },
            tileType: {
                type: String,
                default: "",
                required: !1
            },
            isFeatured: {
                type: Boolean,
                default: !1,
                required: !1
            }
        },
        data() {
            return {
                selectedVariant: null,
                features_expanded: !1,
                cta1Class: "o-btn o-btn--outline",
                cta2Class: "o-btn o-btn--fill",
                product_category: this.product.type.includes("Wire") ? "hardware" : "accessories"
            }
        },
        computed: {
            features() {
                let t = [];
                return t = this.product.tags.reduce((t,i)=>(e.product_features[i] && t.push(e.product_features[i]),
                t), []),
                t.sort((e,t)=>e.order - t.order),
                t
            },
            variantDisplayPrice() {
                return e.utils.toMoney(this.selectedVariant.price, {
                    cents: !0
                })
            },
            variantCompareAtPrice() {
                return !!(this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price) && e.utils.toMoney(this.selectedVariant.compare_at_price, {
                    cents: !0
                })
            },
            colourOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    const i = t.name.toLowerCase();
                    (i.includes("color") || i.includes("colour")) && (e = t)
                }
                ),
                e || !1
            },
            selectedColour() {
                return !!this.colourOption.values && this.colourOption.values[0]
            },
            sizeOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    t.name.toLowerCase().includes("size") && (e = t)
                }
                ),
                e || !1
            },
            styleOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    t.name.toLowerCase().includes("connectivity") && (e = t)
                }
                ),
                e || !1
            },
            packOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    t.name.toLowerCase().includes("pack") && (e = t)
                }
                ),
                e || !1
            },
            badge() {
                let e;
                if (this.product.tags && this.product.tags.length) {
                    const t = this.product.tags.filter(this.checkForBadge);
                    t.length && (e = t.map(this.formatBadgeLabel).join(", "))
                }
                return e || !1
            },
          saveTag() {
                let e;
              console.log(2,"this.product.tags");
                if (this.product.tags && this.product.tags.length) {
                 
                    const t = this.product.tags.filter(this.checkForSave);
                    t.length && (e = t.map(this.formatSaveLabel).join(", "))
                }
                return e || !1
            },
            saleTag() {
                let e;
                if (this.product.tags && this.product.tags.length) {
                    const t = this.product.tags.filter(this.checkForSale);
                    t.length && (e = t.map(this.formatSaleLabel).join(", "))
                }
                return e || !1
            },
            saleTag2() {
                let e;
                if (this.product.tags && this.product.tags.length) {
                    const t = this.product.tags.filter(this.checkForSale2);
                    t.length && (e = t.map(this.formatSaleLabel2).join(", "))
                }
                return e || !1
            },
            modifierClass() {
                let e = `c-product-tile--${this.product_category} `;
                return this.modifier && (Array.isArray(this.modifier) ? e += this.modifier.map(e=>`c-product-tile--${e}`).join(" ") : e += `c-product-tile--${this.modifier}`),
                e
            },
            wrapperModifierClass() {
                let e = `c-product-tile__wrapper--${this.product_category} `;
                return this.modifier && (Array.isArray(this.modifier) ? e += this.modifier.map(e=>`c-product-tile__wrapper--${e}`).join(" ") : e += `c-product-tile__wrapper--${this.modifier}`),
                e
            },
            isActive() {
                return "bundle" === this.tileType && e.bundleDataStore.state.bundleProduct === this.product ? "is-active" : ""
            },
            isInStock() {
                return null === this.selectedVariant.inventory_management || "continue" === this.selectedVariant.inventory_policy || this.selectedVariant.inventory_quantity > 0
            }
        },
        mounted() {
            this.modifier.includes("narrow") && (this.cta1Class = "o-btn o-btn--fill o-btn--tiny",
            this.cta2Class = "o-btn o-btn--outline o-btn--tiny")
        },
        created() {
            this.selectedVariant = this.product.variants.find(e=>e.id === this.product.selected_or_first_available_variant.id)
        },
        methods: {
            addToCart(t) {
                if (!t)
                    throw Error("Cart.add: No item was passed.");
                if (null === t.inventory_management || "continue" === t.inventory_policy || t.inventory_quantity > 0) {
                    const i = {};
                    if (i.id = t.id,
                    i.quantity = 1,
                    "holiday-bundle" !== this.tileType)
                        e.cart.add(i).then(t=>{
                            e.vue_event_bus.$emit("Cart:add", t);location.href = '/cart';
                        }
                        ).catch(e=>{
                            throw Error("Failed adding to the cart.", e)
                        }
                        );
                    else {
                        const s = `bundle_${t.id}`;
                        i.properties = {
                            _bundleID: s
                        };
                        const r = [];
                        r.push(e.cart.add(i, {
                            silent: !0
                        }));
                        const o = {
                            id: 31156268007511,
                            quantity: 1,
                            properties: {
                                _bundleParentID: s
                            }
                        };
                        r.push(e.cart.add(o, {
                            silent: !0
                        })),
                        Promise.all(r).then(()=>{
                            e.vue_event_bus.$emit("Cart:add")
                        }
                        )
                    }
                }
            },
            toggleFeatures() {
                this.features_expanded = !this.features_expanded
            },
            featuresTransitionHandler(e) {
                e.target === this.$refs.featuresWrapper && this.$emit("features-expanded", this.product)
            },
            checkForBadge: e=>e.startsWith("_badge::"),
            formatBadgeLabel: e=>e.replace("_badge::", "").split("_").map(e=>e.charAt(0).toUpperCase() + e.substring(1)).join(" "),
      		checkForSave: e=>e.startsWith("_save::"),
            formatSaveLabel: e=>e.replace("_save::", "").split("_").map(e=>e.charAt(0).toUpperCase() + e.substring(1)).join(" "),
            checkForSale: e=>e.startsWith("_sale30::"),
            formatSaleLabel: e=>e.replace("_sale30::", "").split("_").map(e=>e.charAt(0).toUpperCase() + e.substring(1)).join(" "),
            checkForSale2: e=>e.startsWith("_sale20::"),
            formatSaleLabel2: e=>e.replace("_sale20::", "").split("_").map(e=>e.charAt(0).toUpperCase() + e.substring(1)).join(" "),
            selectBundle() {
                e.bundleDataStore.setBundleProductAndVariant(this.product)
            },
            addCustomization() {
                this.$emit("add-option", this.selectedVariant, this.product)
            },
            onProductTileClicked() {
                this.$emit("product-tile-focused", this.product)
            },
            getSizedProdImage(t) {
                let i = "";
                return this.selectedVariant.featured_image ? i = this.selectedVariant.featured_image.src : [i] = this.product.images;
                e.utils.getSizedImageUrl(i, t)
            }
        },
        template: "#js-product-tile"
    })
}
)(window.theme = window.theme || {}, window.Vue),
window.theme = window.theme || {},
window.Vue.component("search-field", {
    inheritAttrs: !1,
    props: {
        name: {
            type: String,
            default: "",
            required: !1
        },
        value: {
            type: String,
            default: "",
            required: !1
        },
        modifier: {
            type: [String, Array],
            default: "",
            required: !1
        }
    },
    data() {
        return {
            search: "",
            labelText: this.$attrs["label-text"] || null,
            inputPlaceholderText: this.$attrs["input-placeholder-text"] || null,
            searchButtonText: this.$attrs["search-button-text"] || null,
            deleteButtonText: this.$attrs["delete-button-text"] || null
        }
    },
    computed: {
        modifierClass() {
            return this.modifier ? Array.isArray(this.modifier) ? this.modifier.map(e=>`c-search-field--${e}`).join(" ") : `c-search-field--${this.modifier}` : ""
        },
        inputId() {
            return this.name ? `q-${this.name}-search-field-input` : "q-search-field-input"
        },
        hasContent() {
            return "" !== this.search
        }
    },
    methods: {
        deleteSearch() {
            this.search = "",
            this.$emit("input", this.search)
        }
    },
    template: "#js-search-field"
}),
window.Vue.component("size-toggle", {
    props: {
        modifier: {
            type: [String, Array],
            default: "",
            required: !1
        },
        sizeOption: {
            type: Object,
            default: null,
            required: !1
        },
        selectedSize: {
            type: String,
            default: "Standard Size",
            required: !1
        }
    },
    data: ()=>({
        is_active: !0
    }),
    computed: {
        modifierClass() {
            return this.modifier ? `o-toggle--${this.modifier}` : ""
        },
        selectedSizeLabel() {
            return this.selectedSize.toLowerCase().includes("mini") ? "Mini" : "Standard"
        }
    },
    methods: {
        toggle() {
            if (this.selectedSize && this.sizeOption) {
                const e = "Mini" === this.selectedSizeLabel ? "Standard" : "Mini";
                this.$emit("update-size", e)
            }
        }
    },
    template: "#js-size-toggle"
}),
window.Vue.component("style-toggle", {
    props: {
        modifier: {
            type: [String, Array],
            default: "",
            required: !1
        },
        styleOption: {
            type: Object,
            default: null,
            required: !1
        },
        selectedStyle: {
            type: String,
            default: "USB-A",
            required: !1
        }
    },
    data: ()=>({
        is_active: !0
    }),
    computed: {
        modifierClass() {
            return this.modifier ? `o-toggle--${this.modifier}` : ""
        },
        selectedStyleLabel() {
            return this.selectedStyle.toLowerCase().includes("usb-a") ? "USB-A" : "USB-C"
        }
    },
    methods: {
        toggle() {
            if (this.selectedStyle && this.styleOption) {
                const e = "USB-A" === this.selectedStyleLabel ? "USB-C" : "USB-A";
                this.$emit("update-style", e)
            }
        }
    },
    template: "#js-style-toggle"
}),
window.Vue.component("product-star-rating", {
    name: "ProductStarRating",
    props: {
        averageRating: {
            type: Number,
            required: !0
        },
        reviewsCount: {
            type: Number,
            default: 0,
            required: !1
        },
        modifier: {
            type: [String, Array],
            default: "",
            required: !1
        },
        reviewUrl: {
            type: String,
            default: null,
            required: !1
        },
        withCount: {
            type: Boolean,
            default: !1
        }
    },
    data: ()=>({
        starsOutput: []
    }),
    computed: {
        modifierClass() {
            return this.modifier ? Array.isArray(this.modifier) ? this.modifier.map(e=>`o-star-rating--${e}`).join(" ") : `o-star-rating--${this.modifier}` : ""
        }
    },
    mounted() {
        let e = this.averageRating;
        const t = [];
        e = 100 * (Math.round(10 * e) / 10).toFixed(1);
        for (let i = 1; i < 6; i += 1) {
            const s = 100 * i
              , r = s - 70;
            e >= s ? t.push("star") : e >= r ? t.push("half-star") : t.push("empty-star")
        }
        this.starsOutput = t
    },
    template: "#js-star-rating-template"
}),
((e,t)=>{
    e.component("swatches", {
        props: {
            modifier: {
                type: [String, Array],
                default: "",
                required: !1
            },
            colourOption: {
                type: Object,
                required: !0
            },
            productID: {
                type: Number,
                required: !0
            },
            selectedColour: {
                type: String,
                required: !0
            },
            showOnMobile: {
                type: Boolean,
                default: !0,
                required: !1
            },
            isBundle: {
                type: Boolean,
                required: !1,
                default: !1
            }
        },
        data() {
            return {
                picked: this.selectedColour,
                componentID: t.utils.uniqueNumber(5)
            }
        },
        computed: {
            pickedColour: {
                get() {
                    return this.isBundle ? t.bundleDataStore.state.bundleProductColour : this.picked
                },
                set(e) {
                    const t = [...document.querySelectorAll(".js-swatch-radio")];
                    t.forEach(e=>e.setAttribute("disabled", "true")),
                    setTimeout(()=>{
                        t.forEach(e=>e.removeAttribute("disabled"))
                    }
                    , 800),
                    this.picked = e,
                    this.$emit("input", e)
                }
            },
            modifierClass() {
                return this.modifier ? Array.isArray(this.modifier) ? this.modifier.map(e=>`o-swatch--${e}`).join(" ") : `o-swatch--${this.modifier}` : ""
            }
        },
        watch: {},
        methods: {
            colourHandle: e=>e.handleize(),
            generateInputID(e) {
                return `color-radio-${e}-${this.productID}-${this.componentID}`
            }
        },
        template: "#js-swatches-template"
    })
}
)(window.Vue, window.theme = window.theme || {}),
((e,t)=>{
    window.Vue.component("variant-selector", {
        props: {
            modifier: {
                type: [String, Array],
                default: "",
                required: !1
            },
            product: {
                type: Object,
                required: !0
            },
            initialVariant: {
                type: Object,
                required: !0
            },
            bundlePicker: {
                type: Boolean,
                required: !1,
                default: !1
            }
        },
        data: ()=>({
            selectedColour: "",
            selectedSize: "standard size",
            selectedStyle: "USB-A",
            selectedPack: "single size",
            showMobileSwatches: !1,
            showMobileSizes: !1,
            showMobileStyles: !1,
            bundleState: e.bundleDataStore && e.bundleDataStore.state || {}
        }),
        computed: {
            retrieveBundleProducts() {
                const {products: e} = this.bundleState.bundleData;
                return e.map(e=>({
                    label: e.title,
                    value: e
                }))
            },
            selectedProduct: {
                get() {
                    return {
                        label: this.bundleState.bundleProduct.title,
                        value: this.bundleState.bundleProduct
                    }
                },
                set(t) {
                    e.bundleDataStore.setBundleProductAndVariant(t.value)
                }
            },
            selectedProductColour: {
                get() {
                    return this.isBundle() ? this.bundleState.bundleProductColour : this.selectedColour
                },
                set(t) {
                    this.isBundle() && (e.bundleDataStore.state.bundleProductColour = t),
                    this.selectedColour = t
                }
            },
            selectedProductSize: {
                get() {
                    return this.isBundle() ? this.bundleState.bundleProductSize : this.selectedSize
                },
                set(t) {
                    this.isBundle() && (e.bundleDataStore.state.bundleProductSize = t),
                    this.selectedSize = t
                }
            },
            selectedProductStyle: {
                get() {
                    return this.isBundle() ? this.bundleState.bundleProductStyle : this.selectedStyle
                },
                set(t) {
                    this.isBundle() && (e.bundleDataStore.state.bundleProductStyle = t),
                    this.selectedStyle = t
                }
            },
            selectedProductPack: {
                get() {
                    return this.isBundle() ? this.bundleState.bundleProductPack : this.selectedPack
                },
                set(t) {
                    this.isBundle() && (e.bundleDataStore.state.bundleProductPack = t), this.selectedPack = t
                }
            },
            variantDisplayPrice() {
                return this.selectedVariant ? e.utils.toMoney(this.selectedVariant.price, {
                    cents: !0
                }) : null
            },
            modifierClass() {
                return this.modifier ? Array.isArray(this.modifier) ? this.modifier.map(e=>`c-variant-selector--${e}`).join(" ") : `c-variant-selector--${this.modifier}` : ""
            },
            selectedVariant() {
                return this.product.variants.filter(e=>{
                    let t = !0
                      , i = !0;
                    if (this.colourOption) {
                        i = !1;
                        const t = e.options[this.colourOption.position - 1];
                        i = this.selectedProductColour === t
                    }
                    if (this.sizeOption) {
                        t = !1;
                        const i = e.options[this.sizeOption.position - 1].toLowerCase()
                          , s = this.selectedProductSize.toLowerCase();
                        ("mini" === s && i.includes("mini") || "standard" === s && !i.includes("mini")) && (t = !0)
                    }
                   if (this.styleOption) {
                        t = !1;
                        const i = e.options[this.styleOption.position - 1].toLowerCase()
                          , s = this.selectedProductStyle.toLowerCase();
                        ("usb-a" === s && i.includes("usb-a") || "usb-c" === s && !i.includes("usb-a")) && (t = !0)
                    }
                    if (this.packOption) {
                        t = !1;
                        const i = e.options[this.packOption.position - 1].toLowerCase()
                          , s = this.selectedProductPack.toLowerCase();
                        ("twin pack" === s && i.includes("twin pack") || "single" === s && !i.includes("twin pack")) && (t = !0)
                    }
                    return i && t
                }
                )[0]
            },
            colourOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    const i = t.name.toLowerCase();
                    (i.includes("color") || i.includes("colour")) && (e = t)
                }
                ),
                e || !1
            },
            sizeOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    t.name.toLowerCase().includes("size") && (e = t)
                }
                ),
                e || !1
            },
            styleOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    t.name.toLowerCase().includes("connectivity") && (e = t)
                }
                ),
                e || !1
            },
            packOption() {
                let e;
                return this.product.options_with_values.forEach(t=>{
                    t.name.toLowerCase().includes("pack") && (e = t)
                }
                ),
                e || !1
            }
        },
        watch: {
            selectedVariant(t) {
                const i = t;
                i && (this.colourOption && (i.colourHandle = this.getVariantOptionValue(i, this.colourOption).handleize(),
                void 0 !== e.slideGallery && e.slideGallery.go(i.id)),
                this.$emit("update-selected-variant", i))
            }
        },
        created() {
            this.updateValuesFromVariant(this.initialVariant)
        },
        methods: {
            isBundle() {
                return !(!Object.keys(this.bundleState).length || !this.bundleState.bundleData.products.some(e=>this.product.id === e.id))
            },
            openFitGuide() {
                e.vue_event_bus.$emit("ProductPage:show-fit-guide")
            },
            updateValuesFromVariant(e) {
                let t = null;
                this.colourOption && (t = this.getVariantOptionValue(e, this.colourOption),this.selectedColour = t);
                let i = null;
                this.sizeOption && (i = this.getVariantOptionValue(e, this.sizeOption),i.toLowerCase().includes("mini") ? this.selectedSize = "Mini" : this.selectedSize = "Standard")
               
                let s = null;
                this.styleOption && (s = this.getVariantOptionValue(e, this.styleOption),s.toLowerCase().includes("usb-a") ? this.selectedStyle = "usb-a" : this.selectedStyle = "usb-c")
                 
                let x = null;
              	this.packOption && (x = this.getVariantOptionValue(e, this.packOption), this.selectedPack = x);
            },
            updateSelectedSize(e) {
                this.selectedProductSize = e
            },
            updateSelectedStyle(e) {
                this.selectedProductStyle = e;
            },
            updateSelectedPack(e) {
                this.selectedProductPack = e
            },
            getVariantOptionValue: (e,t)=>e.options[t.position - 1],
            colourHandle: e=>e.handleize(),
            toggleShowMobileSwatches() {
                this.showMobileSwatches = !this.showMobileSwatches,
                this.showMobileSizes = !1,
                this.showMobileStyles = !1
            },
            toggleShowMobileSizes() {
                this.showMobileSizes = !this.showMobileSizes,
                this.showMobileSwatches = !1,
                this.showMobileStyles = !1
            },
            toggleShowMobileStyles() {
                this.showMobileStyles = !this.showMobileStyles,
                this.showMobileSwatches = !1,
                this.showMobileSizes = !1
            }
        },
        template: "#js-variant-selector-template"
    })
}
)(window.theme = window.theme || {}),
window.theme = window.theme || {},
window.Vue.component("accessible-select", {
    props: {
        options: {
            type: Array,
            required: !0
        },
        placeholder: {
            type: String,
            required: !1,
            default: ""
        },
        modifier: {
            type: String,
            required: !1,
            default: ""
        },
        selectId: {
            type: String,
            required: !0
        },
        valuePropertyName: {
            type: String,
            required: !1,
            default: "value"
        },
        name: {
            type: String,
            required: !1,
            default: ""
        }
    },
    data() {
        return {
            labelPropertyName: this.$attrs.label || "label"
        }
    },
    computed: {
        picked: {
            get() {
                return this.$attrs.value
            },
            set(e) {
                this.$attrs.value = e,
                this.$emit("input", e)
            }
        }
    },
    watch: {},
    methods: {
        nativePickValue(e) {
            this.picked = this.options.find(t=>t[this.valuePropertyName] === e)
        }
    },
    template: "#js-accessible-select-template"
}),
window.theme = window.theme || {},
window.Vue.component("AmbassadorTile", {
    props: {
        article: {
            type: Object,
            required: !0
        }
    },
    data() {
        return {
            passion: this.article.passion || ""
        }
    },
    template: "#js-ambassador-tile-template"
}),
((e,t)=>{
    window.Vue.component("bundle-tile", {
        props: {
            modifier: {
                type: String,
                default: "",
                required: !1
            },
            pageHandle: {
                type: String,
                required: !0
            },
            product: {
                type: Object,
                required: !0
            }
        },
        data: ()=>({
            selectedVariant: null
        }),
        computed: {
            getVariantImage() {
                let t = null;
                return t = this.selectedVariant.featured_image && this.selectedVariant.featured_image.src ? e.utils.getSizedImageUrl(this.selectedVariant.featured_image.src, "284x") : e.utils.getSizedImageUrl(this.product.images[0], "284x"),
                t
            }
        },
        created() {
            const e = this.product.tags.filter(e=>"_bundle" === e.split("::")[0]);
            if (e.length) {
                let t = !1;
                if (e.forEach(e=>{
                    const i = e.split("::");
                    if (i[1] === this.pageHandle)
                        if (t = !0,
                        3 === i.length) {
                            const t = i[2]
                              , s = this.product.variants.find(e=>String(e.id) === t);
                            if (!s)
                                throw Error(`Invalid tag ${e}, variant ${t} does not exist in product`);
                            this.selectedVariant = s
                        } else
                            2 === i.length && this.setSelectedToDefault()
                }
                ),
                !t)
                    throw Error(`Invalid product "${this.product.title}", no tags matching bundle page "${this.pageHandle}"`)
            } else
                this.setSelectedToDefault()
        },
        methods: {
            addCustomization() {
                this.$emit("add-option", this.selectedVariant, this.product)
            },
            setSelectedToDefault() {
                this.selectedVariant = this.product.variants.find(e=>e.id === this.product.selected_or_first_available_variant.id)
            }
        },
        template: "#js-bundle-tile"
    })
}
)(window.theme = window.theme || {}),
((e,t)=>{
    t.component("bundler", {
        props: {
            bundleState: {
                type: Object,
                required: !0
            },
            selectedVariant: {
                type: Object,
                required: !0
            }
        },
        data: ()=>({
            flickityOptions: {
                draggable: ">1",
                pageDots: !1,
                prevNextButtons: !0,
                contain: !0,
                imagesLoaded: !0,
                groupCells: !0,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 65,
                    y2: 50,
                    x3: 15
                }
            },
            customizations: [null, null, null],
            currentIndex: 0
        }),
        computed: {
            getCustomizationStage() {
                return this.currentIndex + 1
            },
            getProductImage() {
                return this.getImage(this.selectedVariant.featured_image.src, "56x56")
            },
            bundleOptions() {
                return Object.values(this.bundleState.bundleData.bundleOptions)[this.currentIndex]
            },
            isBundleValid() {
                return !this.customizations.some(e=>Object.is(e, null))
            }
        },
        watch: {
            bundleOptions() {
                this.$nextTick(()=>{
                    this.$refs.flickityBundler.init()
                }
                )
            }
        },
        methods: {
            getKey: (e,t)=>`${e.id}-${t}`,
            getImage: (t,i)=>e.utils.getSizedImageUrl(t, i),
            getAddonImage(e) {
                let t = "";
                return t = e.selectedVariant.featured_image ? e.selectedVariant.featured_image.src : e.product.featured_image,
                this.getImage(t, "56x56")
            },
            configureOptions(e, t) {
                2 !== this.currentIndex && this.$refs.flickityBundler.destroy(),
                this.customizations.splice(this.currentIndex, 1, {
                    selectedVariant: e,
                    product: t
                }),
                this.nextCustomization()
            },
            nextCustomization() {
                this.currentIndex < 2 && (this.customizations[this.currentIndex + 1] || this.customizations[this.currentIndex]) && (this.$refs.flickityBundler.destroy(),
                this.currentIndex += 1)
            },
            previousCustomization() {
                this.currentIndex > 0 && (this.$refs.flickityBundler.destroy(),
                this.currentIndex -= 1)
            },
            goToOption(e) {
                (this.customizations[e] || this.customizations[e - 1]) && (this.currentIndex !== e && this.$refs.flickityBundler.destroy(),
                this.currentIndex = e)
            },
            addToCart() {
                const t = this.customizations.map(e=>e.selectedVariant).sort((e,t)=>e.id - t.id).reduce((e,t)=>`${e}-${t.id.toString(36)}`, "")
                  , i = `bundle_${this.selectedVariant.id}${t}`
                  , s = {
                    url: SiteURL("add"),
                    id: this.selectedVariant.id,
                    quantity: 1,
                    properties: {
                        _bundleID: i
                    }
                }
                  , r = [];
                r.push(e.cart.add(s, {
                    silent: !0
                })),
                this.customizations.forEach(t=>{
                    const s = {
                        id: t.selectedVariant.id,
                        quantity: 1,
                        properties: {
                            _bundleParentID: i
                        }
                    };
                    r.push(e.cart.add(s, {
                        silent: !0
                    }))
                }
                ),
                Promise.all(r).then(()=>{
                    this.$emit("bundle-added")
                }
                )
            }
        },
        template: "#js-bundler"
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t,i)=>{
    t.component("cart-line-item", {
        props: {
            item: {
                type: Object,
                required: !0
            }
        },
        data() {
            return {
                quantityMax: 10,
                bundleChildren: this.item.bundleChildren || null,
                infinite: !0,
                colourHandle: "",
                sizeHandle: ""
            }
        },
        computed: {
            price() {
                return e.utils.toMoney(this.item.line_price, {
                    cents: !0
                })
            }
        },
        mounted() {
            if (this.colourHandle = this.getColourHandle(this.item),
            this.sizeHandle = this.getSizeHandle(this.item),
            this.item.variant) {
                const e = null === this.item.variant.inventory_management || "continue" === this.item.variant.inventory_policy;
                this.infinite = e,
                e || (this.quantityMax = Math.min(10, this.item.variant.inventory_quantity))
            }
        },
        methods: {
            handleQuantityChange(t, i) {
                const s = Math.min(i.target.value, this.quantityMax);
                if (this.bundleChildren) {
                    const i = e=>({
                        id: e.key,
                        quantity: s
                    })
                      , r = [i(t), ...this.bundleChildren.map(i)];
                    e.cart.update(r)
                } else
                    e.cart.change({
                        id: t.key,
                        quantity: s
                    })
            },
            debouncedQuantityChange: i.debounce(400, (function(e, t) {
                "" !== t.target.value && this.handleQuantityChange(e, t)
            }
            )),
            removeItem(t) {
                if (this.bundleChildren) {
                    console.log(...this.bundleChildren.map(e=>e.key));
                    const i = [t.key, ...this.bundleChildren.map(e=>e.key)];
                    e.cart.remove(i)
                } else
                    e.cart.remove(t.key)
            },
            getColourHandle(e) {
                let t = !1;
                return e.options_with_values.forEach(e=>{
                    const i = e.name.toLowerCase();
                    (i.includes("color") || i.includes("colour")) && (t = e.value.handleize())
                }
                ),
                t
            },
            getSizeHandle(e) {
                let t = !1;
                return e.options_with_values.forEach(e=>{
                    e.name.toLowerCase().includes("size") && (t = e.value.toLowerCase().includes("mini") ? "Mini" : "Standard")
                }
                ),
                t
            }
        },
        template: "#js-cart-line-item"
    })
}
)(window.theme = window.theme || {}, window.Vue, jQuery),
window.Vue.component("vue-checkbox", {
    model: {
        event: "change",
        prop: "checked"
    },
    props: {
        modifier: {
            type: [String, Array],
            default: "",
            required: !1
        },
        name: {
            type: String,
            default: "",
            required: !1
        },
        checked: {
            type: Boolean,
            default: !1,
            required: !1
        }
    },
    data: ()=>({
        isFocused: !1
    }),
    methods: {
        toggle(e) {
            this.$emit("change", e.target.checked)
        },
        toggleFocus() {
            this.isFocused = !this.isFocused
        }
    },
    template: "#js-checkbox-template"
}),
window.theme = window.theme || {},
window.Vue.component("comparison-tile", {
    props: {
        product: {
            type: Object,
            required: !0
        },
        isSelected: {
            type: Boolean,
            required: !1,
            default: !1
        }
    },
    template: "#js-comparison-tile-template"
}),
((e,t)=>{
    window.Vue.component("EventTile", {
        mixins: [e.vue_mixins.tagProcessors, e.vue_mixins.articleObject],
        props: {
            article: {
                type: Object,
                required: !0
            },
            mini: {
                type: Boolean,
                required: !1,
                default: !1
            }
        },
        data() {
            return {
                eventLocation: this.getTagTextFromArray(this.article.tags, "_location::") || "",
                articlePreview: this.$options.filters.truncateText(this.article.content, 200) || "",
                eventURLDomain: this.article.external_url && new URL(this.article.external_url).hostname.replace("www.", "") || "",
                isOpen: !1,
                contentTruncated: this.article.content.length > 200
            }
        },
        watch: {
            isOpen(e) {
                this.articlePreview = e ? this.article.content : this.$options.filters.truncateText(this.article.content, 200) || ""
            }
        },
        methods: {
            toggleOpen() {
                this.isOpen = !this.isOpen
            }
        },
        template: "#js-event-tile-template"
    })
}
)(window.theme = window.theme || {}),
((e,t)=>{
    e.component("featured-prods", {
        props: {
            bundleState: {
                type: Object,
                required: !0
            },
            title: {
                type: String,
                default: "",
                required: !1
            },
            ctatext: {
                type: String,
                default: "",
                required: !1
            },
            ctaurl: {
                type: String,
                default: "",
                required: !1
            }
        },
        data() {
            return {
                flickityOptions: {
                    draggable: !0,
                    pageDots: !1,
                    prevNextButtons: !1,
                    contain: !0,
                    imagesLoaded: !0,
                    watchCSS: !0,
                    freeScroll: !0,
                    adaptiveHeight: !0,
                    on: {
                        ready() {
                            setTimeout(()=>{
                                this.element.classList.add("is-ready")
                            }
                            , 1e3)
                        }
                    }
                },
                products: this.bundleState.bundleData.products
            }
        },
        methods: {
            onProductTileFocused(e) {
                this.selectBundleProduct(e),
                this.resizeFlickity()
            },
            onHeightChange() {
                this.resizeFlickity()
            },
            resizeFlickity() {
                this.$refs.flickity.$el.classList.remove("is-ready"),
                this.$refs.flickity.resize(),
                setTimeout(()=>{
                    this.$refs.flickity.$el.classList.add("is-ready")
                }
                , 0)
            },
            selectBundleProduct(e) {
                t.bundleDataStore.setBundleProduct(e)
            }
        },
        template: "#js-featured-prods-template"
    })
}
)(window.Vue, window.theme = window.theme || {}),
window.Vue.component("modal", {
    props: {
        classHook: {
            type: [String, Array],
            default: "",
            required: !1
        }
    },
    methods: {
        handleModalMouseDown(e) {
            e.target.closest(".c-modal__wrapper") || this.$emit("close")
        }
    },
    template: "#js-vue-modal"
}),
((e,t,i)=>{
    const s = "product"
      , r = "page"
      , o = "article";
    t.component("search-box", {
        props: {
            uniqueId: {
                type: String,
                default: "",
                required: !1
            },
            modifier: {
                type: [String, Array],
                default: "",
                required: !1
            }
        },
        data: ()=>({
            searchTerm: null,
            searchResults: {
                products: {},
                articles: {}
            },
            isSearching: !1,
            isUpdatingSearchResults: !1
        }),
        computed: {
            productResults() {
                let e = null;
                return this.searchResults.products.items && this.searchResults.products.items.length && (e = {
                    title: this.searchResults.products.searchTypes[0],
                    seeAllUrl: this.searchResults.products.seeAll,
                    items: this.searchResults.products.items
                }),
                e
            },
            showResults() {
                return this.searchTerm && !this.isSearching
            },
            articleResults() {
                let e = null;
                return this.searchResults.articles.items && this.searchResults.articles.items.length && (e = {
                    title: this.searchResults.articles.searchTypes[0],
                    seeAllUrl: this.searchResults.articles.seeAll,
                    items: this.searchResults.articles.items
                }),
                e
            },
            searchSummary() {
                const e = [];
                return this.productResults && e.push({
                    title: this.productResults.title,
                    items: this.productResults.items.slice(0, 2),
                    seeAllUrl: this.productResults.seeAllUrl
                }),
                this.articleResults && e.push({
                    title: this.articleResults.title,
                    items: this.articleResults.items.slice(0, 2),
                    seeAllUrl: this.articleResults.seeAllUrl
                }),
                e
            }
        },
        watch: {
            isUpdatingSearchResults(e) {
                e || (this.isSearching = !1)
            }
        },
        created() {
            this.debouncedSearch = $.debounce(800, this.updateSearchResults)
        },
        methods: {
            getSearchResult(e) {
                return i.get(`/search?view=json&type=${e}&q=${this.searchTerm}`).then(e=>e.data)
            },
            getSearchResults() {
                return Promise.all([this.getSearchResult(s), this.getSearchResult(o), this.getSearchResult(r)])
            },
            async updateSearchResults() {
                this.isUpdatingSearchResults = !0;
                const e = await this.getSearchResults()
                  , {0: t, 1: i} = e;
                this.searchResults.products = t,
                this.searchResults.articles = i,
                this.isUpdatingSearchResults = !1
            },
            onSearchInput() {
                this.isSearching = !0,
                this.debouncedSearch()
            }
        },
        template: "#js-search"
    })
}
)(window.theme = window.theme || {}, window.Vue, window.axios),
((e,t)=>{
    window.Vue.component("StoryTile", {
        mixins: [e.vue_mixins.tagProcessors, e.vue_mixins.articleObject],
        props: {
            article: {
                type: Object,
                required: !0
            },
            hasAlternateLink: {
                type: Boolean,
                required: !1,
                default: !1
            }
        },
        data() {
            return {
                articleTitle: this.article.title,
                articleCTAString: this.article.person ? `Read ${this.article.person}'s story` : "Read the Story",
                target: "_self"
            }
        },
        mounted() {
            this.articleTitle.length > 70 && (this.articleTitle = this.articleTitle.slice(0, 70).concat("...")),
            this.hasAlternateLink && (this.article.url = this.article.content,
            this.target = "_blank")
        },
        template: "#js-story-tile-template"
    })
}
)(window.theme = window.theme || {}),
((e,t)=>{
    window.Vue.component("bundle-gallery", {
        data: ()=>({
            state: e.bundleDataStore.state
        }),
        computed: {
            featuredImage() {
                const t = this.state.bundleProduct.featured_image;
                return e.utils.getSizedImageUrl(t, "1000x")
            }
        },
        template: "#js-bundle-gallery"
    })
}
)(window.theme = window.theme || {}),
((e,t,i,s,r)=>{
    if (document.querySelector(".js-account")) {
        const o = document.querySelector(".js-address-modal")
          , a = i.helpers.regex("zip", /^ *([AaBbCcEeGgHhJjKkLlMmNnPpRrSsTtVvXxYy]\d[a-zA-Z]) *-* *(\d[a-zA-Z]\d) *$|^ *(\d{5}) *$|^ *(\d{5}) *-* *(\d{4}) *$/)
          , n = i.helpers.regex("phone", /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/);
        t.account = new e({
            el: ".js-account",
            name: "AccountPage",
            data: {
                customer: t.customer,
                addressID: null,
                isEditingAddress: !1,
                isDeletingAddress: !1,
                isAddingAddress: !1,
                pages: {
                    orders: !0,
                    addresses: !1,
                    communications: !1
                },
                isLoading: !1,
                communications: [{
                    name: "Communication type 1",
                    isSubscribed: !1
                }, {
                    name: "Communication type 2",
                    isSubscribed: !0
                }, {
                    name: "Communication type 3",
                    isSubscribed: !1
                }, {
                    name: "Communication type 4",
                    isSubscribed: !1
                }],
                showModal: !1,
                provinces: [],
                selectedAddress: {
                    first_name: "",
                    last_name: "",
                    company:"",
                    address1: "",
                    address2: "",
                    city: "",
                    province: "",
                    province_code: "",
                    country_name: "",
                    zip: "",
                    phone: "",
                    default: !1
                }
            },
            validations: {
                selectedAddress: {
                    zip: {
                        zipValidation: a
                    },
                    phone: {
                        phoneNumberValidation: n
                    }
                }
            },
            methods: {
                show(e) {
                    this.hideUnselected(e),
                    this.pages[e] = !0
                },
                closeModal() {
                    this.showModal = !1,
                    s.enableBodyScroll(o)
                },
                buildProvinceSelector(e) {
                    this.provinces = JSON.parse(e.dataset.provinces).map(e=>e[0])
                },
                openModal() {                   
                    this.showModal = 1,                                   
                    s.enableBodyScroll(o)
                },
                hideUnselected(e) {
                    Object.keys(this.pages).forEach(t=>{
                        t !== e && (this.pages[t] = !1)
                    }
                    )
                },
                toggleDetails(e) {
                    if (e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.orderId) {
                        const t = e.currentTarget.dataset.orderId
                          , i = document.getElementById(t)
                          , s = "is-active"
                          , r = e.currentTarget.dataset.textActive
                          , o = e.currentTarget.dataset.textInactive;
                        i.classList.contains(s) ? (e.currentTarget.classList.remove(s),
                        i.classList.remove(s),
                        e.currentTarget.firstChild.textContent = o) : (e.currentTarget.classList.add(s),
                        i.classList.add(s),
                        e.currentTarget.firstChild.textContent = r)
                    }
                },
                toggleAddressModal() {
                    this.showModal = !this.showModal,
                    this.showModal ? (this.$nextTick(()=>{
                        !this.isDeletingAddress && this.$refs.countrySelector.selectedOptions.length && this.buildProvinceSelector(this.$refs.countrySelector.selectedOptions[0])
                    }
                    ),
                    s.disableBodyScroll(o)) : s.enableBodyScroll(o)
                },
                retrieveCurrentAddress() {
                    const e = this.customer.addresses.find(e=>e.id === this.addressID)
                      , i = _objectSpread({}, e);
                    ["first_name", "last_name", "address1", "address2", "city"].forEach(s=>{
                        i[s] = t.utils.decodeHTML(e[s])
                    }
                    ),
                    this.selectedAddress = _objectSpread({}, i)
                },
                clearCurrentAddress() {
                    this.selectedAddress = {
                        first_name: "",
                        last_name: "",
                        address1: "",
                        address2: "",
                        city: "",
                        province_name: "",
                        province_code: "",
                        country_name: "",
                        zip: "",
                        phone: ""
                    }
                },
                hideAddressForms() {
                    this.isEditingAddress = !1,
                    this.isDeletingAddress = !1,
                    this.isAddingAddress = !1
                },
                modifyAddress(e, t=!1) {
                    switch (this.hideAddressForms(),
                    this.openModal(),
                    this.addressID = t || !1,
                    this.clearCurrentAddress(),
                    e) {
                    case "add":
                        this.isAddingAddress = !0;
                        break;
                    case "edit":
                        this.retrieveCurrentAddress(),
                        this.isEditingAddress = !0,
                        this.$nextTick(()=>{this.buildProvinceSelector(this.$refs.countrySelector.selectedOptions[0])});
                        break;
                    case "delete":                        
                        this.retrieveCurrentAddress(),
                        this.isDeletingAddress = !0;
                        break;
                    case "cancel_address":
                        this.closeModal(),
                        this.isAddingAddress = !1;
                        this.isEditingAddress = !1;
                        this.isDeletingAddress = !1;
                    }
                },
                retrieveAddresses: ()=>r.get("/account/addresses?view=json").then(e=>e.data),
                refreshAddresses() {
                    return this.retrieveAddresses().then(e=>{
                        this.customer.addresses = e
                    }
                    )
                },
                postAddressModifications(e) {
                    e.preventDefault();
                    const t = new FormData(e.target);
                    if (this.$v.$touch(),
                    this.$v.$invalid)
                        throw Error("Invalid Form input data.");
                    this.addressID ? (this.isLoading = !0,
                    r.post(`/account/addresses/${this.addressID}`, t).then(()=>this.refreshAddresses()).then(()=>{
                        this.isLoading = !1,
                        this.toggleAddressModal()
                    }
                    )) : (this.isLoading = !0,
                    r.post("/account/addresses", t).then(()=>this.refreshAddresses()).then(()=>{
                        this.isLoading = !1,
                        this.toggleAddressModal()
                    }
                    ))
                }
            }
        })
    }
}
)(window.Vue, window.theme = window.theme || {}, window.validators = window.validators || {}, window.bodyScrollLock, window.axios),
((e,t)=>{
    document.querySelector(".js-article-page") && new t({
        el: ".js-article-page",
        name: "ArticlePage",
        mixins: [e.vue_mixins.tagProcessors, e.vue_mixins.articleObject],
        data: ()=>({
            article: e.article,
            mainCategoryTag: "",
            dateOptions: {
                day: "numeric",
                month: "long",
                year: "numeric"
            }
        }),
        mounted() {
            this.mainCategoryTag = this.getTagTextFromArray(this.article.tags, "_category::") || e.blog.title
        }
    })
}
)(window.theme = window.theme || {}, window.Vue);
const tagTypes = ["category", "location"];
function wrapWords(e, t) {
    return e.replace(/\w+[,.'"!?&-]?/g, t || "<span><span>$&</span></span>")
}
((e,t)=>{
    document.querySelector(".js-blog-page") && new t({
        el: ".js-blog-page",
        name: "BlogPage",
        mixins: [e.vue_mixins.tagProcessors],
        data: ()=>({
            blog: e.blog,
            selectedTags: tagTypes.reduce((e,t)=>_objectSpread({}, e, {
                [t]: null
            }), {}),
            selectOptions: {},
            initialised: !1
        }),
        watch: {
            selectedTags: {
                deep: !0,
                handler(e) {
                    if (this.initialised) {
                        const t = e=>e.replace("::", "-").handleize("-", "_")
                          , i = tagTypes.map(t=>e[t]).filter(Boolean);
                        if (i.length) {
                            const e = i.map(e=>t(e.value)).join("+");
                            window.location.href = `/blogs/${this.blog.handle}/tagged/${e}`
                        } else
                            window.location.href = `/blogs/${this.blog.handle}`
                    }
                }
            }
        },
        created() {
            if (e.blog.all_tags) {
                const t = t=>{
                    const i = e.blog.all_tags.filter(e=>this.checkForTagType(e, t));
                    i && (this.selectOptions[t] = i.map(e=>this.convertTagToObject(e, t)))
                }
                ;
                tagTypes.forEach(t)
            }
            this.initialiseSelectedTags()
        },
        methods: {
            convertTagToObject(e, t) {
                return {
                    label: this.getTagText(e, `_${t}::`),
                    value: e
                }
            },
            checkForTagType: (e,t)=>e.startsWith(`_${t}::`),
            initialiseSelectedTags() {
                if (e.blog.current_tags) {
                    const t = (e,t)=>{
                        const i = e.find(e=>this.checkForTagType(e, t));
                        if (i) {
                            const e = this.getTagText(i, `_${t}::`);
                            this.selectedTags[t] = {
                                value: i,
                                label: e
                            }
                        }
                    }
                    ;
                    tagTypes.forEach(i=>{
                        t(e.blog.current_tags, i)
                    }
                    ),
                    this.$nextTick(()=>{
                        this.initialised = !0
                    }
                    )
                } else
                    this.initialised = !0
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t)=>{
    document.querySelector(".js-cart-flyout") && new t({
        el: ".js-cart-flyout",
        name: "CartFlyout",
        data: {
            cart: e.cart
        },
        computed: {
            filteredPrice() {
                if (this.topLevelItems) {
                    const t = this.topLevelItems.reduce((e,t)=>e + t.line_price, 0);
                    return e.utils.toMoney(t, {
                        cents: !0
                    })
                }
                return "loading..."
            },
            topLevelItems() {
                let e = [];
                const t = {};
                return this.cart.content.items.forEach(i=>{
                    i.properties && i.properties._bundleParentID ? t[i.properties._bundleParentID] ? t[i.properties._bundleParentID].push(i) : t[i.properties._bundleParentID] = [i] : e.push(i)
                }
                ),
                e = e.map(e=>{
                    if (e.properties && e.properties._bundleID) {
                        const i = t[e.properties._bundleID];
                        e.bundleChildren = i,
                        delete t[e.properties._bundleID]
                    }
                    return e
                }
                ),
                Object.keys(t).length && Object.keys(t).forEach(i=>{
                    const s = t[i];
                    e = e.concat(s)
                }
                ),
                e
            },
            totalPriceFormatted() {
                return e.utils.toMoney(this.cart.content.total_price, {
                    cents: !0
                })
            }
        },
        watch: {
            cart: {
                deep: !0,
                handler: e=>{
                    const t = $(".js-cart-header-icon");
                    e.content.items.length > 0 ? t.removeClass("is-empty") : t.addClass("is-empty")
                }
            }
        },
        created() {
            const t = ()=>{
                $('[data-flyout-toggle="cart-flyout"]').first().trigger("click")
            }
            ;
            "#cart" === window.location.hash && setTimeout(()=>{
                t()
            }
            , 500),
            e.vue_event_bus.$on("Cart:add", ()=>{
                t()
            }
            )
        },
        methods: {
            Increment(t) {
                e.cart.change({
                    id: t.key,
                    quantity: t.quantity + 1
                })
            },
            Decrement(t) {
                t.quantity > 1 && e.cart.change({
                    id: t.key,
                    quantity: t.quantity - 1
                })
            },
            subtotalPrice() {
                const t = this.cart.content.original_total_price;
                return t > 0 ? e.utils.toMoney(t, {
                    cents: !0,
                    no_zeros: !0
                }) : "$0.00"
            },
            totalPrice() {
                const t = this.cart.content.total_price;
                return t > 0 ? e.utils.toMoney(t, {
                    cents: !0,
                    no_zeros: !0
                }) : "$0.00"
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue, window.axios),
((e,t)=>{
    const i = {
        cellAlign: "left",
        pageDots: !1,
        prevNextButtons: !0,
        groupCells: !0,
        watchCSS: !0,
        contain: !0,
        freeScroll: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 65,
            y2: 50,
            x3: 15
        }
    };
    document.querySelector(".js-community-page") && new t({
        el: ".js-community-page",
        name: "CommunityPage",
        data: ()=>({
            stories: [],
            events: [],
            ambassadors: [],
            stringifyFlickityOptions: JSON.stringify(i)
        }),
        mounted() {
            ["stories", "events", "ambassadors"].forEach(e=>{
                const t = document.getElementById(`js-community-data-${e}`);
                if (t) {
                    const i = JSON.parse(t.innerHTML);
                    this[e] = i.articles
                }
            }
            )
        }
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t)=>{
    document.querySelector(".js-comparison-page") && new t({
        el: ".js-comparison-page",
        name: "ComparisonPage",
        mixins: [e.vue_mixins.stickyHandlers],
        data: ()=>({
            comparisonProducts: JSON.parse(document.getElementById("js-comparison-product-data").innerHTML).filter(e=>e.handle),
            firstSelectedProduct: null,
            secondSelectedProduct: null,
            currentPage: 1,
            lastPositionSelected: 1,
            showAllSpecs: !1
        }),
        computed: {
            selectedProductHandles() {
                return [this.firstSelectedProduct && this.firstSelectedProduct.handle, this.secondSelectedProduct && this.secondSelectedProduct.handle]
            },
            specsArray() {
                return ["Battery life", "Standby time", "Weight", "Water resistance", "Microphone", "Wireless range", "Multipoint pairing", "Titanium band", "Charge time", "Charger", "Battery type", "Moisture detector", "Command controls", "Back-a-track", "Frequency response", "Sensitivity", "Microphone sensitivity", "Compatible profiles", "Compatible codecs", "Warranty"].map(e=>({
                    name: e.replace("_", " "),
                    firstProductValue: this.firstSelectedProduct.specs[e],
                    secondProductValue: this.secondSelectedProduct.specs[e]
                }))
            }
        },
        watch: {
            currentPage() {
                window.scrollTo(0, 0)
            }
        },
        mounted() {
            this.comparisonProducts = this.comparisonProducts.map(e=>{
                const t = e;
                return t.colourOption = this.getColourOption(e),
                t
            }
            )
        },
        methods: {
            toMoney: t=>e.utils.toMoney(t, {
                cents: !0
            }),
            selectProduct(e) {
                this.firstSelectedProduct && this.firstSelectedProduct.handle === e.handle || this.secondSelectedProduct && this.secondSelectedProduct.handle === e.handle || (1 === this.lastPositionSelected ? (this.firstSelectedProduct = e,
                this.lastPositionSelected = 0) : (this.secondSelectedProduct = e,
                this.lastPositionSelected = 1))
            },
            compareProducts() {
                this.firstSelectedProduct && this.secondSelectedProduct && (this.currentPage = 2)
            },
            getColourOption(e) {
                let t;
                return e.options_with_values.forEach(e=>{
                    const i = e.name.toLowerCase();
                    (i.includes("color") || i.includes("colour")) && (t = e)
                }
                ),
                t || !1
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t,i)=>{
    document.querySelector(".js-faq-categories") && new t({
        el: ".js-faq-categories",
        name: "FAQCategories",
        data: {
            search: "",
            sectionSettings: JSON.parse(document.getElementById("js-faq-categories-data").innerHTML)
        },
        computed: {
            filteredCategories() {
                if (0 === this.search.trim().length)
                    return this.sectionSettings.categories;
                const e = {
                    threshold: .4,
                    keys: ["questionsAnswers.answer", "questionsAnswers.question"]
                };
                let t = new i(this.sectionSettings.categories,e);
                return t.search(this.search).reduce((s,r)=>{
                    const o = _objectSpread({}, r);
                    return e.keys = ["question", "answer"],
                    t = new i(o.questionsAnswers,e),
                    o.questionsAnswers = t.search(this.search),
                    s.push(o),
                    s
                }
                , [])
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue, window.Fuse),
((e,t)=>{
    document.querySelector(".js-featured-prods") && new t({
        el: ".js-featured-prods",
        name: "FeaturedProds",
        data: {
            state: e.bundleDataStore && e.bundleDataStore.state || {}
        }
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t)=>{
    document.querySelector(".js-featured-video-gallery") && new t({
        el: ".js-featured-video-gallery",
        name: "FeaturedVideoGallery",
        data: ()=>({
            activeVideo: 1,
            playingVideo: !1
        }),
        computed: {},
        watch: {
            activeVideo(e, t) {
                const i = t - 1;
                document.querySelectorAll(".js-youtube-embed")[i].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*"),
                this.playingVideo = !1
            }
        },
        mounted() {},
        methods: {
            setActiveVideo(e) {
                this.activeVideo = e
            },
            isPlaying(e) {
                return e === this.activeVideo && this.playingVideo
            },
            playVideo(e) {
                this.$refs[e].src += "&autoplay=1",
                this.playingVideo = !0
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t,i)=>{
    const s = document.querySelector(".js-fit-guide-modal");
    document.querySelector(".js-fit-guide-modal") && new t({
        el: ".js-fit-guide-modal",
        name: "FitGuide",
        data: {
            showFitGuide: !1,
            currentStep: 1,
            totalSteps: 3,
            selectedImageSrcset: "",
            selectedImageAlt: "",
            selectedImageIndex: 1,
            firstStep: !0,
            lastStep: !1
        },
        watch: {
            currentStep() {
                this.$nextTick(()=>{
                    this.firstStep = 1 === this.currentStep,
                    this.lastStep = this.currentStep === this.totalSteps
                }
                )
            }
        },
        created() {
            e.vue_event_bus.$on("ProductPage:show-fit-guide", this.openFitGuide);
            const t = document.querySelector(".js-fit-guide-thumb");
            t && (this.selectedImageSrcset = t.getAttribute("srcset"),
            this.selectedImageAlt = t.getAttribute("alt"));
            const i = document.querySelectorAll(".js-fit-guide-step");
            i.length && (this.totalSteps = i.length)
        },
        methods: {
            openFitGuide() {
                this.showFitGuide = !0,
                i.disableBodyScroll(s)
            },
            closeFitGuide() {
                this.showFitGuide = !1,
                i.enableBodyScroll(s),
                this.currentStep = 1
            },
            next() {
                this.currentStep += 1
            },
            previous() {
                this.currentStep -= 1
            },
            selectImage(e, t, i) {
                this.selectedImageSrcset = e,
                this.selectedImageAlt = t,
                this.selectedImageIndex = i
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue, window.bodyScrollLock),
((e,t,i)=>{
    if (document.querySelector(".js-customer-login")) {
        const s = {
            email: {
                email: i.email,
                required: i.required
            },
            password: {
                minLength: i.minLength(5),
                required: i.required
            }
        }
          , r = {
            email: {
                email: i.email,
                required: i.required
            }
        }
          , o = {
            email: {
                email: i.email,
                required: i.required
            },
            password: {
                minLength: i.minLength(5),
                required: i.required
            },
            firstName: {
                alpha: i.alpha,
                required: i.required
            },
            lastName: {
                alpha: i.alpha,
                required: i.required
            }
        }
          , a = {
            password: {
                minLength: i.minLength(5),
                required: i.required
            },
            repeatPassword: {
                sameAsPassword: i.sameAs("password"),
                required: i.required
            }
        };
        new t({
            el: ".js-customer-login",
            name: "CustomerLogin",
            data: {
                email: null,
                password: null,
                repeatPassword: null,
                firstName: null,
                lastName: null,
                pageStates: {
                    login: !0,
                    register: !1,
                    recover_password: !1,
                    reset_password: !1
                },
                acceptsMarketing: !1,
                template: e.template.name
            },
            validations() {
                let e = {};
                return this.pageStates.login && (e = _objectSpread({}, s)),
                this.pageStates.recover_password && (e = _objectSpread({}, r)),
                this.pageStates.register && (e = _objectSpread({}, o)),
                this.pageStates.reset_password && (e = _objectSpread({}, a)),
                e
            },
            computed: {
                loginState() {
                    return this.pageStates.login
                },
                registerState() {
                    return this.pageStates.register
                },
                recoverPasswordState() {
                    return this.pageStates.recover_password
                },
                resetPasswordState() {
                    return this.pageStates.reset_password
                }
            },
            created() {
                const t = window.location.search
                  , i = new URLSearchParams(t);
                i.has("page") ? this.show(i.get("page")) : this.show(e.template.name)
            },
            methods: {
                show(e) {
                    window.history.pushState({
                        id: e
                    }, "", `${window.location.pathname}?page=${e}`),
                    this.hideAll(),
                    this.clearFields(),
                    this.pageStates[e] = !0,
                    this.$v.$reset()
                },
                hideAll() {
                    Object.keys(this.pageStates).forEach(e=>{
                        this.pageStates[e] = !1
                    }
                    )
                },
                clearFields() {
                    this.email = null,
                    this.password = null,
                    this.repeatPassword = null,
                    this.firstName = null,
                    this.lastName = null
                }
            }
        })
    }
}
)(window.theme = window.theme || {}, window.Vue, window.validators = window.validators || {}),
((e,t,i)=>{
    const s = ".js-product-bundle-newsletter-modal"
      , r = document.querySelector(s);
    r && new e({
        el: s,
        name: "ProductBundleNewsletterModal",
        data: {
            showModal: !1,
            email: null
        },
        validations: {
            email: {
                email: t.email,
                required: t.required
            }
        },
        watch: {
            showModal() {
                localStorage.setItem("product_bundle_newsletter_modal", "true")
            }
        },
        created() {
            localStorage.getItem("product_bundle_newsletter_modal") || this.openModal()
        },
        methods: {
            openModal() {
                i.disableBodyScroll(r),
                this.showModal = !0
            },
            closeModal() {
                i.enableBodyScroll(r),
                this.showModal = !1
            }
        }
    })
}
)(window.Vue, window.validators, window.bodyScrollLock),
((e,t,i)=>{
    if (document.querySelector(".js-product-page")) {
        const s = document.querySelector("js-bundle-modal");
        new t({
            el: ".js-product-page",
            name: "ProductPage",
            mixins: [e.vue_mixins.stickyHandlers],
            data: {
                selectedVariant: {},
                productCategory: "hardware",
                vsPlaceholderStyle: {
                    height: 0
                },
                isBundlePicker: !1,
                isBundlerOpen: !1,
                bundleState: e.bundleDataStore && e.bundleDataStore.state || {},
                atcBarReady: !0
            },
            computed: {
                variantDisplayPrice() {
                    return e.utils.toMoney(this.selectedVariant.price, {
                        cents: !0
                    })
                },
                variantCompareAtPrice() {
                    return !!(this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price) && e.utils.toMoney(this.selectedVariant.compare_at_price, {
                        cents: !0
                    })
                },
                colourOption() {
                    let e;
                    return this.product.options_with_values.forEach(t=>{
                        const i = t.name.toLowerCase();
                        (i.includes("color") || i.includes("colour")) && (e = t)
                    }
                    ),
                    e || !1
                },
                sizeOption() {
                    let e;
                    return this.product.options_with_values.forEach(t=>{
                        t.name.toLowerCase().includes("size") && (e = t)
                    }
                    ),
                    e || !1
                },
                styleOption() {
                    let e;
                    return this.product.options_with_values.forEach(t=>{
                        t.name.toLowerCase().includes("connectivity") && (e = t)
                    }
                    ),
                    e || !1
                },
                packOption() {
                    let e;
                    return this.product.options_with_values.forEach(t=>{
                        t.name.toLowerCase().includes("pack") && (e = t)
                    }
                    ),
                    e || !1
                },
                product() {
                    return this.isBundlePicker ? this.bundleState.bundleProduct : e.product
                },
                isInStock() {
                    return null === this.selectedVariant.inventory_management || "continue" === this.selectedVariant.inventory_policy || this.selectedVariant.inventory_quantity > 0
                }
            },
            created() {
                document.getElementById("js-bundle-data") && (this.isBundlePicker = !0),
                this.selectedVariant = this.product.selected_or_first_available_variant,
                this.productCategory = this.product.type.includes("Wire") ? "hardware" : "accessories"
            },
            mounted() {
                const e = document.getElementsByClassName("js-variant-selector-holder");
                if (e.length) {
                    const t = e[0].offsetHeight;
                    this.vsPlaceholderStyle = {
                        height: `${t}px`
                    }
                }
            },
            methods: {
                addToCart(t) {
                    if (!t)
                        throw Error("Cart.add: No item was passed.");
                    const i = {};
                    i.id = t.id,
                    i.url = SiteURL("add"),
                    i.quantity = 1,
                    e.cart.add(i).then(t=>{
                       e.vue_event_bus.$emit("Cart:add", t);location.href = '/cart';
                    }
                    ).catch(e=>{
                        throw Error("Failed adding to the cart.", e)
                    }
                    )
                },
                toggleBundleModal() {
                    this.isBundlerOpen = !this.isBundlerOpen,
                    this.isBundlerOpen ? i.disableBodyScroll(s) : i.enableBodyScroll(s)
                },
                updateProductData(e) {
                    this.product = _objectSpread({}, e)
                },
                bundleAdded() {
                    this.isBundlerOpen = !1,
                    i.enableBodyScroll(s),
                    e.vue_event_bus.$emit("Cart:add")
                },
                scrollToWarranty(e) {
                    window.scrollToEvent(e)
                }
            }
        })
    }
}
)(window.theme = window.theme || {}, window.Vue, window.bodyScrollLock),
((e,t,i)=>{
    const s = e.locales.products.product.high_reviews
      , r = e.locales.products.product.customer_reviews;
    document.querySelector(".js-product-reviews") && new t({
        el: ".js-product-reviews",
        name: "ProductReviews",
        data: {
            flickityOptions: {
                pageDots: !1,
                prevNextButtons: !1,
                autoPlay: !1,
                contain: !0,
                freeScroll: !0
            },
            productReviews: [],
            currentPage: 1,
            currentCell: 0,
            bottomline: null,
            isFormVisible: !1,
            activeReview: {},
            modalIsOpen: !1,
            observer: null
        },
        computed: {
            isLoaded() {
                return this.productReviews.length > 0
            },
            renderHeading() {
                const e = this.bottomline.star_distribution[5];
                return 0 === e ? r : e < 10 ? `${e} ${s}` : e % 10 == 0 ? `${e} ${s}` : `Over ${10 * Math.floor(e / 10)} ${s}`
            }
        },
        mounted() {
            this.loadReviewsInfo(),
            this.observer = new IntersectionObserver(([e])=>{
                e && e.isIntersecting ? e.playPlayer() : e.pausePlayer()
            }
            )
        },
        methods: {
            getReviewsInfo() {
                const t = e.product.id
                  , s = {
                    per_page: "20",
                    page: this.currentPage,
                    sort: "rating"
                };
                return i(`https://api.yotpo.com/v1/widget/1ha25Ixb0fzxa05gdggiANxSFGsK4mdwm0ctF6mF/products/${t}/reviews.json`, {
                    params: s
                }).then(e=>e.data.response).catch(e=>{
                    throw Error("Failed retrieving reviews for product.", e)
                }
                )
            },
            loadReviewsInfo() {
                return this.getReviewsInfo().then(e=>{
                    this.productReviews.push(...e.reviews),
                    this.bottomline = e.bottomline
                }
                )
            },
            appendReviews() {
                this.currentPage += 1,
                this.getReviewsInfo().then(e=>{
                    this.productReviews.push(...e.reviews),
                    this.$nextTick(()=>{
                        this.$refs.flickity.rerender()
                    }
                    )
                }
                ).then(()=>{
                    this.$refs.flickity.selectCell(this.currentCell, !1, !0)
                }
                )
            },
            toggleForm() {
                this.isFormVisible = !this.isFormVisible,
                this.isFormVisible && (document.querySelector(".yotpo .write-review-wrapper").style.display = "",
                document.querySelector(".yotpo .yotpo-thank-you").style.display = "")
            },
            initFlickity() {
                this.$refs.flickity.on("change", ()=>{
                    this.$refs.flickity.selectedIndex() !== this.$refs.flickity.cells().length - 1 && this.$refs.flickity.selectedIndex() + 1 === this.$refs.flickity.cells().length - 10 && (this.currentCell = this.$refs.flickity.selectedIndex(),
                    this.appendReviews())
                	window.dispatchEvent(new Event('resize'))
                }
                )
            },
            resizeFlickity() {
                this.$nextTick(()=>{
                    this.$refs.flickity.resize()
                }
                )
            },
            readReview(e) {
                this.activeReview = e,
                this.openModal()
            },
            openModal() {
                this.modalIsOpen = !0,
                document.body.classList.add("noscroll")
            },
            closeModal() {
                this.modalIsOpen = !1,
                document.body.classList.remove("noscroll")
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue, window.axios),
((e,t)=>{
    document.querySelector(".js-products-grid") && new t({
        el: ".js-products-grid",
        name: "ProductsGrid",
        data: {
            products: e.products.list,
            flickityOptions: {
                draggable: !0,
                pageDots: !1,
                prevNextButtons: !1,
                contain: !0,
                imagesLoaded: !0,
                watchCSS: !0,
                freeScroll: !0,
                on: {
                    ready() {
                        setTimeout(()=>{
                            this.element.classList.add("is-ready")
                        }
                        , 1e3)
                    }
                }
            }
        },
        methods: {
            onHeightChange() {
                this.$refs.flickity.$el.classList.remove("is-ready"),
                this.$refs.flickity.resize(),
                setTimeout(()=>{
                    this.$refs.flickity.$el.classList.add("is-ready")
                }
                , 0)
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t)=>{
    document.querySelector(".js-search-articles") && new t({
        el: ".js-search-articles",
        name: "SearchArticles",
        data: ()=>({
            articles: e.searchArticles
        })
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t)=>{
    document.querySelector(".js-vue-search-flyout") && new t({
        el: ".js-vue-search-flyout",
        name: "SearchFlyout",
        data: ()=>({})
    })
}
)(window.theme = window.theme || {}, window.Vue),
((e,t)=>{
    document.querySelector(".js-support-page") && new t({
        el: ".js-support-page",
        name: "SupportPage",
        data: {
            supportSearchTerm: "",
            selectedProductGuide: null,
            productGuides: JSON.parse(document.getElementById("js-product-guides-data") && document.getElementById("js-product-guides-data").innerHTML)
        },
        computed: {
            buildProductSupportPageURL() {
                let t = null;
                return this.selectedProductGuide && (t = `${e.shop.url}/pages/product-guide-${this.selectedProductGuide.value.handle}`),
                t
            },
            productImage() {
                let {image: e} = this.productGuides[0];
                return this.selectedProductGuide && (e = this.selectedProductGuide.value.image),
                e
            },
            productGuideSelectOptions() {
                return this.productGuides.map(e=>({
                    label: e.name,
                    value: e
                }))
            }
        },
        methods: {
            submitSearchQuery() {
                window.location.assign(`/search?type=article&q=${this.supportSearchTerm}+tag:support`)
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue, window.axios),
((e,t,i,s,r,o)=>{
    document.querySelector(".js-video-explainer") && new t({
        el: ".js-video-explainer",
        name: "VideoExplainer",
        data: ()=>({
            currentSlide: 0,
            steps: [0, 2.8, 5.8, 9.9],
            explainerFlickity: null,
            scrollWheelInitialized: !1,
            scrollJackingActive: !0
        }),
        watch: {
            currentSlide(e) {
                this.scrollJackingActive && e >= 3 && setTimeout(()=>{
                    this.scrollJackingActive = !1
                }
                , 600)
            }
        },
        mounted() {
            this.explainerFlickity = new i(this.$refs.slider,{
                fade: !0,
                cellAlign: "left",
                selectedAttraction: .03,
                draggable: !1
            }),
            this.explainerFlickity.on("change", this.onSlideChange),
            s(window).width() > 996 ? this.initialiseScrollWheel() : (document.querySelector("body").style.touchAction = "none",
            this.initialiseTouchScroll()),
            s(window).on("resize orientationChange", ()=>{
                s(window).width() > 996 && !this.scrollWheelInitialized ? this.initialiseScrollWheel() : (document.querySelector("body").style.touchAction = "none",
                this.initialiseTouchScroll())
            }
            ),
            this.playTillStep(1)
        },
        methods: {
            initialiseScrollWheel() {
                if (!this.scrollWheelInitialized) {
                    this.scrollWheelInitialized = !0;
                    const e = s.throttle(1e3, !0, ()=>{
                        this.explainerFlickity.next()
                    }
                    )
                      , t = s.throttle(1e3, !0, ()=>{
                        this.explainerFlickity.previous()
                    }
                    );
                    r(this.$refs.slider, i=>{
                        const s = o(i).pixelY;
                        this.scrollJackingActive && (i.preventDefault(),
                        s > 30 ? e() : s < -30 && t())
                    }
                    )
                }
            },
            initialiseTouchScroll() {
                let e = null;
                const t = s.throttle(1e3, !0, ()=>{
                    this.explainerFlickity.next()
                }
                )
                  , i = s.throttle(1e3, !0, ()=>{
                    this.explainerFlickity.previous()
                }
                );
                window.addEventListener("touchstart", t=>{
                    e = t.changedTouches[0]
                }
                ),
                window.addEventListener("touchmove", ()=>{
                    this.scrollJackingActive || (document.querySelector("body").style.touchAction = "")
                }
                ),
                window.addEventListener("touchend", s=>{
                    let r = s.changedTouches[0];
                    this.scrollJackingActive && (r.screenY - e.screenY < 0 ? t() : i())
                }
                )
            },
            onSlideChange(e) {
                const t = this.$refs.video
                  , i = s(t);
                e === this.currentSlide + 1 && t.currentTime + .6 > this.steps[e] ? this.playTillStep(e + 1) : (i.addClass("is-transitioning"),
                setTimeout(()=>{
                    t.currentTime = this.steps[e],
                    this.playTillStep(e + 1)
                }
                , 200),
                setTimeout(()=>{
                    i.removeClass("is-transitioning")
                }
                , 400)),
                this.currentSlide = e
            },
            playTillStep(e) {
                const t = this.$refs.video;
                let i = this.steps[e];
                void 0 === i && (i = t.duration),
                s(t).off("timeupdate").on("timeupdate", (function() {
                    t.currentTime >= i && t.pause()
                }
                )),
                t.play()
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue, window.Flickity, jQuery, window.addWheelListener, window.normalizeWheel),
$(()=>{
   "/cart1" === location.pathname && (document.location.href = "/#cart1")
}
);
const navHeight = 108
  , $content = document.querySelector(".t--scrollable")
  , ratio = 1.5;
let resizeTimer, windowWidth = window.outerWidth;
if (window.addEventListener("resize", ()=>{
    windowWidth !== window.outerWidth && (document.body.classList.add("is-resizing"),
    clearTimeout(resizeTimer),
    resizeTimer = setTimeout(()=>{
        document.body.classList.remove("is-resizing"),
        windowWidth = window.outerWidth
    }
    , 400))
}
),
"IntersectionObserver"in window) {
    !function() {
        window.scrollTo(0, 0),
        document.querySelector("body").classList.add("ready");
        const e = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
          , t = new TimelineMax({
            paused: !0,
            onComplete: ()=>{
                document.querySelector("body").classList.add("is-loaded")
            }
        })
          , i = new TimelineMax({
            paused: !0
        });
        if (null === sessionStorage.getItem("initialLoad") && document.querySelector(".t--text-hero")) {
            const e = document.querySelector(".t--text-hero");
            e.innerHTML = wrapWords(e.innerHTML),
            t.staggerTo(document.querySelectorAll(".t--text-hero span > span"), 1.2, {
                ease: Expo.easeOut,
                y: "0%",
                overwrite: "all",
                delay: .12
            }, .09)
        }
        t.play(0),
        document.querySelectorAll("a:not([target='_blank'])").forEach(e=>{
            e.href.startsWith("#") || e.addEventListener("click", ()=>{
                i.play(0)
            }
            )
        }
        );
        const s = t=>{
            t.preventDefault();
            const i = t.target.getAttribute("href")
              , {scrollTo: s} = t.target.dataset;
            s ? TweenMax.to(window, 1, {
                scrollTo: {
                    y: document.querySelector(s).offsetTop - 108
                },
                ease: Expo.easeInOut
            }) : i && i.match(/^#/) ? TweenMax.to(window, 1, {
                scrollTo: {
                    y: document.querySelector(i).offsetTop - 108
                },
                ease: Expo.easeInOut
            }) : TweenMax.to(window, 1, {
                scrollTo: {
                    y: e - 108
                },
                ease: Expo.easeInOut
            })
        }
          , r = document.querySelectorAll(".js-scroll");
        r.length && r.forEach(e=>{
            e.addEventListener("click", e=>{
                s(e)
            }
            )
        }
        ),
        window.scrollToEvent = s;
        const o = new IntersectionObserver(e=>{
            e.forEach(e=>{
                const t = e.boundingClientRect.y < 0;
                e.target.classList.remove("is-in"),
                t ? e.target.classList.add("is-out", "is-out--up") : e.target.classList.add("is-out", "is-out--down"),
                e.isIntersecting && (e.target.classList.add("is-in"),
                e.target.classList.remove("is-out", "is-out--up", "is-out--down"))
            }
            )
        }
        ,{
            rootMargin: "0px",
            threshold: 0
        });
        if (document.querySelectorAll(".t--ty").forEach(e=>{
            o.observe(e)
        }
        ),
        document.querySelector(".js-feature-stability")) {
            const e = document.querySelector(".js-feature-stability");
            new IntersectionObserver(e=>{
                e.forEach(e=>{
                    e.isIntersecting ? e.target.classList.add("is-in") : e.target.classList.remove("is-in")
                }
                )
            }
            ,{
                rootMargin: "75px 0px",
                threshold: 0
            }).observe(e)
        }
    }()
}
const waterEffect = document.querySelector(".js-water");
let bgSprite, displacementSprite, displacementFilter, pointerSprite, pointerFilter, app, stage;
var spriteWidth = 1440
  , spriteHeight = 845;
let containerHeight;
var newWidth, newHeight;
const resizeHandler = ()=>{
    if (newWidth = window.innerWidth,
    theme.utils.isMatchingMedia(theme.breakpoints.tablet, "min")) {
        containerHeight = 750;
        const e = Math.max(window.innerWidth / spriteWidth, containerHeight / spriteHeight);
        newHeight = Math.ceil(spriteHeight * e),
        stage.scale.set(e)
    } else
        newHeight = newWidth,
        stage.scale.set(1);
    app.renderer.view.style.width = "100%",
    app.renderer.view.style.height = "100%",
    app.renderer.resize(newWidth, newHeight)
}
;
function onPointerMove(e) {
    pointerSprite.visible = !0,
    pointerSprite.position.set(e.data.global.x - 25, e.data.global.y - 25)
}
function setup(e, t) {
    resizeHandler(),
    app.stage.addChild(stage),
    window.addEventListener("resize", resizeHandler),
    bgSprite = new PIXI.Sprite(t.bg.texture),
    bgSprite.interactive = !0,
    displacementSprite = new PIXI.Sprite(t.clouds.texture),
    displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT,
    displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite),
    pointerSprite = new PIXI.Sprite(t.clouds.texture),
    pointerFilter = new PIXI.filters.DisplacementFilter(pointerSprite),
    displacementSprite.width = bgSprite.width,
    displacementSprite.height = bgSprite.height,
    spriteHeight = bgSprite.height,
    spriteWidth = bgSprite.width,
    pointerSprite.anchor.set(.5),
    pointerFilter.scale.x = 7,
    pointerFilter.scale.y = 7,
    stage.addChild(bgSprite),
    stage.addChild(displacementSprite),
    stage.addChild(pointerSprite),
    stage.filters = [displacementFilter, pointerFilter],
    pointerSprite.visible = !1,
    app.ticker.add(e=>{
        displacementSprite.x += 3.5 * e,
        displacementSprite.y += 3.5 * e,
        displacementSprite.x > displacementSprite.width && (displacementSprite.x = 0,
        displacementSprite.y = 0)
    }
    )
}
if (waterEffect) {
    const e = [{
        name: "bg",
        url: waterEffect.dataset.bg
    }, {
        name: "clouds",
        url: "https://raw.githubusercontent.com/pixijs/examples/gh-pages/examples/assets/pixi-filters/displacement_map_repeat.jpg"
    }]
      , t = {
        autoDensity: !0,
        backgroundColor: 16777215,
        resizeTo: window,
        resolution: window.devicePixelRatio || 1,
        view: waterEffect
    };
    app = new PIXI.Application(t),
    stage = new PIXI.Container,
    app.loader.add(e).load(setup)
}
((e,t)=>{
    t(()=>{
        const e = t(".js-featured-video-play-button");
        e && e.on("click", e=>{
            const i = t(e.target).closest(".js-featured-video");
            e.preventDefault(),
            i.find("iframe").src += "&autoplay=1",
            i.addClass("is-active")
        }
        )
    }
    )
}
)(window.theme = window.theme || {}, jQuery),
((e,t)=>{
    window.addEventListener("load", (function() {
        const i = document.querySelector(".js-nav-bar-list");
        if (void 0 !== i && null != i && !("ontouchstart"in window || navigator.maxTouchPoints) && (s = i).scrollWidth > s.offsetWidth) {
            const s = new t(i,{
                cellAlign: "left",
                freeScroll: !0,
                prevNextButtons: !1,
                pageDots: !1,
                contain: !0
            });
            e.navBarSlider = s
        }
        var s
    }
    ))
}
)(theme, Flickity),
(e=>{
    function t(e, t) {
        const i = e;
        i.classList.toggle("is-active"),
        i.children[0].innerHTML = t
    }
    document.addEventListener("click", i=>{
        const s = document.querySelector(".js-product-specs-list-wrap");
        i.target.closest(".js-toggle-product-specs-button") && s && function(i, s) {
            if (i.classList.contains("is-active"))
                return function(e) {
                    e.classList.remove("is-active")
                }(i),
                void t(s, e.locales.products.product.show_full_specs);
            !function(e) {
                e.classList.add("is-active")
            }(i),
            t(s, e.locales.products.product.hide_full_specs)
        }(s, document.querySelector(".js-toggle-product-specs-button"))
    }
    ),
    document.addEventListener("click", e=>{
        e.target.closest(".js-product-benefit-header") && e.target.closest(".js-product-benefit-header").parentElement.classList.toggle("is-active")
    }
    )
}
)(window.theme = window.theme || {}),
(e=>{
    function t() {
        navigator.geolocation.getCurrentPosition(t=>{
            const i = {
                lat: t.coords.latitude,
                lng: t.coords.longitude
            };
            (new e.maps.Geocoder).geocode({
                location: i
            }, (e,t)=>{
                "OK" === t && e[0] && (document.getElementById("address_search").value = e[0].formatted_address,
                document.getElementById("submitBtn").click())
            }
            )
        }
        )
    }
    if (void 0 !== window.fixURLS) {
        !function() {
            const e = document.querySelector(".search_bar")
              , t = `<div class="search_bar_inner">\n                                <h2 class="search_bar_title">Find in-store</h2>\n                                ${e.innerHTML}\n                              </div>`;
            e.innerHTML = t
        }(),
        function() {
            const e = document.getElementById("within_distance");
            if (e.addEventListener("change", window.codeAddress),
            e) {
                const t = Array.from(e.options);
                t.length && t.forEach(e=>{
                    const t = e;
                    "0" === t.value ? t.textContent = "no limit" : t.textContent = `within ${e.value} miles`
                }
                )
            }
        }(),
        function() {
            const e = document.getElementById("address_search")
              , t = e.value;
            e.onfocus = null,
            e.value = "",
            e.placeholder = t
        }(),
        function() {
            const e = document.querySelector(".main_search_bar")
              , i = document.getElementById("submitBtn")
              , s = i.cloneNode(!0);
            i.parentNode.removeChild(i);
            const r = `<div class="main_search_bar_field">${e.innerHTML}</div>`;
            e.innerHTML = r,
            document.querySelector(".main_search_bar_field").appendChild(s);
            const o = document.createElement("button");
            o.setAttribute("id", "geolocate-button");
            const a = document.createElement("span");
            a.classList.add("u-visually-hidden"),
            a.textContent = "Get my location",
            o.appendChild(a),
            e.appendChild(o),
            o.addEventListener("click", t)
        }(),
        function() {
            const e = document.createElement("h3");
            e.classList.add("addresses_heading"),
            e.textContent = "Stores near you";
            const t = document.createElement("div");
            t.classList.add("addresses_results");
            const i = document.getElementById("addresses_list");
            i.insertBefore(t, i.firstChild),
            i.insertBefore(e, i.firstChild)
        }();
        const e = window.fixURLS;
        window.fixURLS = ()=>{
            if (void 0 === window.boldMap)
                return;
            window.boldMap.setOptions({
                styles: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dadada"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#c9c9c9"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }]
            }),
            e(),
            document.querySelectorAll("#custom_field_id_2203").forEach(e=>{
                e.textContent = e.textContent.replace(/:$/, ""),
                "Yes" === e.nextSibling.textContent && e.classList.add("has-demo-available")
            }
            ),
            document.querySelectorAll(".store_website a").forEach(e=>{
                e.textContent = "Website"
            }
            );
            const t = Array.from(document.getElementById("addresses_list").querySelectorAll("li")).filter(e=>e.hasAttribute("onmouseover"))
              , i = document.querySelector(".addresses_results");
            t && (0 === t.length ? i.textContent = "" : 1 === t.length ? i.textContent = "1 result" : i.textContent = `${t.length} results`)
        }
        ;
        const i = window.add_markers;
        window.add_markers = ()=>{
            mainIcon = "https://cdn.shopify.com/s/files/1/0857/5574/files/store-locator-pin__store-location.png?75851",
            youIcon = "https://cdn.shopify.com/s/files/1/0857/5574/files/store-locator-pin__user-location.png?75851",
            myshadow = "https://cdn.shopify.com/s/files/1/0857/5574/files/store-locator-pin__shadow.png?75851",
            window.add_markers = i,
            window.add_markers()
        }
    }
}
)(window.google),
(e=>{
    document.querySelector(".js-design-guide") && new e({
        el: ".js-design-guide",
        data: {
            exampleDropdownOptions: [{
                value: "Example-Value-1",
                label: "Label for Value 1"
            }, {
                value: "Example-Value-2",
                label: "Label for Value 2"
            }, {
                value: "Example-Value-3",
                label: "Label for Value 3"
            }],
            selectedDropdownOption: null
        }
    })
}
)(window.Vue),
((e,t,i)=>{
    const s = document.querySelector(".js-nav");
    e.header = new t({
        el: ".js-header",
        name: "Header",
        data: {
            isMegaMenuActive: !1,
            isAnimating: !1
        },
        methods: {
            toggleMegamenu() {
                this.isMegaMenuActive ? this.closeMegamenu() : this.openMegamenu()
            },
            openMegamenu() {
                this.isAnimating = !0,
                this.isMegaMenuActive = !0,
                i.disableBodyScroll(s),
                e.vue_event_bus.$emit("open_megamenu")
            },
            closeMegamenu() {
                this.isMegaMenuActive = !1,
                i.enableBodyScroll(s),
                e.vue_event_bus.$emit("close_megamenu"),
                setTimeout(()=>{
                    this.isAnimating = !1
                }
                , 200)
            }
        }
    })
}
)(window.theme = window.theme || {}, window.Vue, window.bodyScrollLock),
document.querySelector(".js-challenge") && setTimeout(()=>{
    window.scrollTo(0, 0)
}
, 300),
(e=>{
    [...document.querySelectorAll(".js-tiny-slider")].forEach(t=>{
        const i = t.dataset.tinySliderOptions ? JSON.parse(t.dataset.tinySliderOptions) : {};
        i.container = i.container || t,
        e(i)
    }
    )
}
)(window.tns),
(()=>{
    let e, t = !1;
    document.body.addEventListener("touchstart", i=>{
        i.target.closest(".flickity-slider") ? (t = !0,
        e = {
            x: i.touches[0].pageX,
            y: i.touches[0].pageY
        }) : t = !1
    }
    ),
    document.body.addEventListener("touchmove", i=>{
        if (!t || !i.cancelable)
            return;
        const s = {
            x: i.touches[0].pageX - e.x,
            y: i.touches[0].pageY - e.y
        };
        Math.abs(s.x) > 7 && i.preventDefault()
    }
    , {
        passive: !1
    })
}
)();


// 导航栏的调节
$("body.active .c-site-header").hover(function(){
    $("#menu-button").addClass("black")
  },function(){
    $("#menu-button").removeClass("black")
  })
    $(window).scroll(function(){
    if($(".c-site-header").hasClass("background-white")){
      $('body').removeClass('active')     
    }else{
    if($('body').hasClass('white-header')){
      $('body').addClass('active')    
    }
    }
   })